/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!(function(a) {
  (a.fn.equalHeights = function() {
    var b = 0,
      c = a(this);
    return (
      c.each(function() {
        var c = a(this).innerHeight();
        c > b && (b = c);
      }),
      c.css('height', b)
    );
  }),
    a('[data-equal]').each(function() {
      var b = a(this),
        c = b.data('equal');
      b.find(c).equalHeights();
    });
})(jQuery);

/* Run function after window resize */
var afterResize = (function() {
  var t = {};
  return function(callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();

window.theme = window.theme || {};

/* ================ VENDOR ================ */
/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */
window.matchMedia||(window.matchMedia=function(){"use strict";var e=window.styleMedia||window.media;if(!e){var t=document.createElement("style"),n=document.getElementsByTagName("script")[0],d=null;t.type="text/css",t.id="matchmediajs-test",n?n.parentNode.insertBefore(t,n):document.head.appendChild(t),d="getComputedStyle"in window&&window.getComputedStyle(t,null)||t.currentStyle,e={matchMedium:function(e){var n="@media "+e+"{ #matchmediajs-test { width: 1px; } }";return t.styleSheet?t.styleSheet.cssText=n:t.textContent=n,"1px"===d.width}}}return function(t){return{matches:e.matchMedium(t||"all"),media:t||"all"}}}());
/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. Dual MIT/BSD license */
!function(){if(window.matchMedia&&window.matchMedia("all").addListener)return!1;var e=window.matchMedia,n=e("only all").matches,i=!1,t=0,a=[],r=function(n){clearTimeout(t),t=setTimeout(function(){for(var n=0,i=a.length;n<i;n++){var t=a[n].mql,r=a[n].listeners||[],o=e(t.media).matches;if(o!==t.matches){t.matches=o;for(var c=0,d=r.length;c<d;c++)r[c].call(window,t)}}},30)};window.matchMedia=function(t){var o=e(t),c=[],d=0;return o.addListener=function(e){n&&(i||(i=!0,window.addEventListener("resize",r,!0)),0===d&&(d=a.push({mql:o,listeners:c})),c.push(e))},o.removeListener=function(e){for(var n=0,i=c.length;n<i;n++)c[n]===e&&c.splice(n,1)},o}}();

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});
/* Modernizr 2.8.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
 */
;window.Modernizr=function(a,b,c){function z(a){j.cssText=a}function A(a,b){return z(m.join(a+";")+(b||""))}function B(a,b){return typeof a===b}function C(a,b){return!!~(""+a).indexOf(b)}function D(a,b){for(var d in a){var e=a[d];if(!C(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function E(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:B(f,"function")?f.bind(d||b):f}return!1}function F(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return B(b,"string")||B(b,"undefined")?D(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),E(e,b,c))}var d="2.8.2",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x={}.hasOwnProperty,y;!B(x,"undefined")&&!B(x.call,"undefined")?y=function(a,b){return x.call(a,b)}:y=function(a,b){return b in a&&B(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:w(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},q.csstransforms=function(){return!!F("transform")},q.csstransforms3d=function(){var a=!!F("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.fontface=function(){var a;return w('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a};for(var G in q)y(q,G)&&(v=G.toLowerCase(),e[v]=q[G](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)y(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" supports-"+(b?"":"no-")+a),e[a]=b}return e},z(""),i=k=null,e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.testProp=function(a){return D([a])},e.testAllProps=F,e.testStyles=w,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" supports-js supports-"+t.join(" supports-"):""),e}(this,this.document);

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/*!
 * imagesLoaded PACKAGED v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/*
 * jQuery FlexSlider v2.2.2
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function(a){a.flexslider=function(b,c){var d=a(b);d.vars=a.extend({},a.flexslider.defaults,c);var j,e=d.vars.namespace,f=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,g=("ontouchstart"in window||f||window.DocumentTouch&&document instanceof DocumentTouch)&&d.vars.touch,h="click touchend MSPointerUp",i="",k="vertical"===d.vars.direction,l=d.vars.reverse,m=d.vars.itemWidth>0,n="fade"===d.vars.animation,o=""!==d.vars.asNavFor,p={},q=!0;a.data(b,"flexslider",d),p={init:function(){d.animating=!1,d.currentSlide=parseInt(d.vars.startAt?d.vars.startAt:0,10),isNaN(d.currentSlide)&&(d.currentSlide=0),d.animatingTo=d.currentSlide,d.atEnd=0===d.currentSlide||d.currentSlide===d.last,d.containerSelector=d.vars.selector.substr(0,d.vars.selector.search(" ")),d.slides=a(d.vars.selector,d),d.container=a(d.containerSelector,d),d.count=d.slides.length,d.syncExists=a(d.vars.sync).length>0,"slide"===d.vars.animation&&(d.vars.animation="swing"),d.prop=k?"top":"marginLeft",d.args={},d.manualPause=!1,d.stopped=!1,d.started=!1,d.startTimeout=null,d.transitions=!d.vars.video&&!n&&d.vars.useCSS&&function(){var a=document.createElement("div"),b=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var c in b)if(void 0!==a.style[b[c]])return d.pfx=b[c].replace("Perspective","").toLowerCase(),d.prop="-"+d.pfx+"-transform",!0;return!1}(),d.ensureAnimationEnd="",""!==d.vars.controlsContainer&&(d.controlsContainer=a(d.vars.controlsContainer).length>0&&a(d.vars.controlsContainer)),""!==d.vars.manualControls&&(d.manualControls=a(d.vars.manualControls).length>0&&a(d.vars.manualControls)),d.vars.randomize&&(d.slides.sort(function(){return Math.round(Math.random())-.5}),d.container.empty().append(d.slides)),d.doMath(),d.setup("init"),d.vars.controlNav&&p.controlNav.setup(),d.vars.directionNav&&p.directionNav.setup(),d.vars.keyboard&&(1===a(d.containerSelector).length||d.vars.multipleKeyboard)&&a(document).bind("keyup",function(a){var b=a.keyCode;if(!d.animating&&(39===b||37===b)){var c=39===b?d.getTarget("next"):37===b?d.getTarget("prev"):!1;d.flexAnimate(c,d.vars.pauseOnAction)}}),d.vars.mousewheel&&d.bind("mousewheel",function(a,b){a.preventDefault();var f=0>b?d.getTarget("next"):d.getTarget("prev");d.flexAnimate(f,d.vars.pauseOnAction)}),d.vars.pausePlay&&p.pausePlay.setup(),d.vars.slideshow&&d.vars.pauseInvisible&&p.pauseInvisible.init(),d.vars.slideshow&&(d.vars.pauseOnHover&&d.hover(function(){d.manualPlay||d.manualPause||d.pause()},function(){d.manualPause||d.manualPlay||d.stopped||d.play()}),d.vars.pauseInvisible&&p.pauseInvisible.isHidden()||(d.vars.initDelay>0?d.startTimeout=setTimeout(d.play,d.vars.initDelay):d.play())),o&&p.asNav.setup(),g&&d.vars.touch&&p.touch(),(!n||n&&d.vars.smoothHeight)&&a(window).bind("resize orientationchange focus",p.resize),d.find("img").attr("draggable","false"),setTimeout(function(){d.vars.start(d)},200)},asNav:{setup:function(){d.asNav=!0,d.animatingTo=Math.floor(d.currentSlide/d.move),d.currentItem=d.currentSlide,d.slides.removeClass(e+"active-slide").eq(d.currentItem).addClass(e+"active-slide"),f?(b._slider=d,d.slides.each(function(){var b=this;b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",function(a){a.preventDefault(),a.currentTarget._gesture&&a.currentTarget._gesture.addPointer(a.pointerId)},!1),b.addEventListener("MSGestureTap",function(b){b.preventDefault();var c=a(this),e=c.index();a(d.vars.asNavFor).data("flexslider").animating||c.hasClass("active")||(d.direction=d.currentItem<e?"next":"prev",d.flexAnimate(e,d.vars.pauseOnAction,!1,!0,!0))})})):d.slides.on(h,function(b){b.preventDefault();var c=a(this),f=c.index(),g=c.offset().left-a(d).scrollLeft();0>=g&&c.hasClass(e+"active-slide")?d.flexAnimate(d.getTarget("prev"),!0):a(d.vars.asNavFor).data("flexslider").animating||c.hasClass(e+"active-slide")||(d.direction=d.currentItem<f?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){d.manualControls?p.controlNav.setupManual():p.controlNav.setupPaging()},setupPaging:function(){var f,g,b="thumbnails"===d.vars.controlNav?"control-thumbs":"control-paging",c=1;if(d.controlNavScaffold=a('<ol class="'+e+"control-nav "+e+b+'"></ol>'),d.pagingCount>1)for(var j=0;j<d.pagingCount;j++){if(g=d.slides.eq(j),f="thumbnails"===d.vars.controlNav?'<img src="'+g.attr("data-thumb")+'"/>':"<a>"+c+"</a>","thumbnails"===d.vars.controlNav&&!0===d.vars.thumbCaptions){var k=g.attr("data-thumbcaption");""!=k&&void 0!=k&&(f+='<span class="'+e+'caption">'+k+"</span>")}d.controlNavScaffold.append("<li>"+f+"</li>"),c++}d.controlsContainer?a(d.controlsContainer).append(d.controlNavScaffold):d.append(d.controlNavScaffold),p.controlNav.set(),p.controlNav.active(),d.controlNavScaffold.delegate("a, img",h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},setupManual:function(){d.controlNav=d.manualControls,p.controlNav.active(),d.controlNav.bind(h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},set:function(){var b="thumbnails"===d.vars.controlNav?"img":"a";d.controlNav=a("."+e+"control-nav li "+b,d.controlsContainer?d.controlsContainer:d)},active:function(){d.controlNav.removeClass(e+"active").eq(d.animatingTo).addClass(e+"active")},update:function(b,c){d.pagingCount>1&&"add"===b?d.controlNavScaffold.append(a("<li><a>"+d.count+"</a></li>")):1===d.pagingCount?d.controlNavScaffold.find("li").remove():d.controlNav.eq(c).closest("li").remove(),p.controlNav.set(),d.pagingCount>1&&d.pagingCount!==d.controlNav.length?d.update(c,b):p.controlNav.active()}},directionNav:{setup:function(){var b=a('<ul class="'+e+'direction-nav"><li><a class="'+e+'prev" href="#">'+d.vars.prevText+'</a></li><li><a class="'+e+'next" href="#">'+d.vars.nextText+"</a></li></ul>");d.controlsContainer?(a(d.controlsContainer).append(b),d.directionNav=a("."+e+"direction-nav li a",d.controlsContainer)):(d.append(b),d.directionNav=a("."+e+"direction-nav li a",d)),p.directionNav.update(),d.directionNav.bind(h,function(b){b.preventDefault();var c;(""===i||i===b.type)&&(c=a(this).hasClass(e+"next")?d.getTarget("next"):d.getTarget("prev"),d.flexAnimate(c,d.vars.pauseOnAction)),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(){var a=e+"disabled";1===d.pagingCount?d.directionNav.addClass(a).attr("tabindex","-1"):d.vars.animationLoop?d.directionNav.removeClass(a).removeAttr("tabindex"):0===d.animatingTo?d.directionNav.removeClass(a).filter("."+e+"prev").addClass(a).attr("tabindex","-1"):d.animatingTo===d.last?d.directionNav.removeClass(a).filter("."+e+"next").addClass(a).attr("tabindex","-1"):d.directionNav.removeClass(a).removeAttr("tabindex")}},pausePlay:{setup:function(){var b=a('<div class="'+e+'pauseplay"><a></a></div>');d.controlsContainer?(d.controlsContainer.append(b),d.pausePlay=a("."+e+"pauseplay a",d.controlsContainer)):(d.append(b),d.pausePlay=a("."+e+"pauseplay a",d)),p.pausePlay.update(d.vars.slideshow?e+"pause":e+"play"),d.pausePlay.bind(h,function(b){b.preventDefault(),(""===i||i===b.type)&&(a(this).hasClass(e+"pause")?(d.manualPause=!0,d.manualPlay=!1,d.pause()):(d.manualPause=!1,d.manualPlay=!0,d.play())),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(a){"play"===a?d.pausePlay.removeClass(e+"pause").addClass(e+"play").html(d.vars.playText):d.pausePlay.removeClass(e+"play").addClass(e+"pause").html(d.vars.pauseText)}},touch:function(){function r(f){d.animating?f.preventDefault():(window.navigator.msPointerEnabled||1===f.touches.length)&&(d.pause(),g=k?d.h:d.w,i=Number(new Date),o=f.touches[0].pageX,p=f.touches[0].pageY,e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g,a=k?p:o,c=k?o:p,b.addEventListener("touchmove",s,!1),b.addEventListener("touchend",t,!1))}function s(b){o=b.touches[0].pageX,p=b.touches[0].pageY,h=k?a-p:a-o,j=k?Math.abs(h)<Math.abs(o-c):Math.abs(h)<Math.abs(p-c);var f=500;(!j||Number(new Date)-i>f)&&(b.preventDefault(),!n&&d.transitions&&(d.vars.animationLoop||(h/=0===d.currentSlide&&0>h||d.currentSlide===d.last&&h>0?Math.abs(h)/g+2:1),d.setProps(e+h,"setTouch")))}function t(){if(b.removeEventListener("touchmove",s,!1),d.animatingTo===d.currentSlide&&!j&&null!==h){var k=l?-h:h,m=k>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(m)&&(Number(new Date)-i<550&&Math.abs(k)>50||Math.abs(k)>g/2)?d.flexAnimate(m,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}b.removeEventListener("touchend",t,!1),a=null,c=null,h=null,e=null}function u(a){a.stopPropagation(),d.animating?a.preventDefault():(d.pause(),b._gesture.addPointer(a.pointerId),q=0,g=k?d.h:d.w,i=Number(new Date),e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g)}function v(a){a.stopPropagation();var c=a.target._slider;if(c){var d=-a.translationX,f=-a.translationY;return q+=k?f:d,h=q,j=k?Math.abs(q)<Math.abs(-d):Math.abs(q)<Math.abs(-f),a.detail===a.MSGESTURE_FLAG_INERTIA?(setImmediate(function(){b._gesture.stop()}),void 0):((!j||Number(new Date)-i>500)&&(a.preventDefault(),!n&&c.transitions&&(c.vars.animationLoop||(h=q/(0===c.currentSlide&&0>q||c.currentSlide===c.last&&q>0?Math.abs(q)/g+2:1)),c.setProps(e+h,"setTouch"))),void 0)}}function w(b){b.stopPropagation();var d=b.target._slider;if(d){if(d.animatingTo===d.currentSlide&&!j&&null!==h){var f=l?-h:h,k=f>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(k)&&(Number(new Date)-i<550&&Math.abs(f)>50||Math.abs(f)>g/2)?d.flexAnimate(k,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}a=null,c=null,h=null,e=null,q=0}}var a,c,e,g,h,i,j=!1,o=0,p=0,q=0;f?(b.style.msTouchAction="none",b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",u,!1),b._slider=d,b.addEventListener("MSGestureChange",v,!1),b.addEventListener("MSGestureEnd",w,!1)):b.addEventListener("touchstart",r,!1)},resize:function(){!d.animating&&d.is(":visible")&&(m||d.doMath(),n?p.smoothHeight():m?(d.slides.width(d.computedW),d.update(d.pagingCount),d.setProps()):k?(d.viewport.height(d.h),d.setProps(d.h,"setTotal")):(d.vars.smoothHeight&&p.smoothHeight(),d.newSlides.width(d.computedW),d.setProps(d.computedW,"setTotal")))},smoothHeight:function(a){if(!k||n){var b=n?d:d.viewport;a?b.animate({height:d.slides.eq(d.animatingTo).height()},a):b.height(d.slides.eq(d.animatingTo).height())}},sync:function(b){var c=a(d.vars.sync).data("flexslider"),e=d.animatingTo;switch(b){case"animate":c.flexAnimate(e,d.vars.pauseOnAction,!1,!0);break;case"play":c.playing||c.asNav||c.play();break;case"pause":c.pause()}},uniqueID:function(b){return b.find("[id]").each(function(){var b=a(this);b.attr("id",b.attr("id")+"_clone")}),b},pauseInvisible:{visProp:null,init:function(){var a=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var b=0;b<a.length;b++)a[b]+"Hidden"in document&&(p.pauseInvisible.visProp=a[b]+"Hidden");if(p.pauseInvisible.visProp){var c=p.pauseInvisible.visProp.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(c,function(){p.pauseInvisible.isHidden()?d.startTimeout?clearTimeout(d.startTimeout):d.pause():d.started?d.play():d.vars.initDelay>0?setTimeout(d.play,d.vars.initDelay):d.play()})}},isHidden:function(){return document[p.pauseInvisible.visProp]||!1}},setToClearWatchedEvent:function(){clearTimeout(j),j=setTimeout(function(){i=""},3e3)}},d.flexAnimate=function(b,c,f,h,i){if(d.vars.animationLoop||b===d.currentSlide||(d.direction=b>d.currentSlide?"next":"prev"),o&&1===d.pagingCount&&(d.direction=d.currentItem<b?"next":"prev"),!d.animating&&(d.canAdvance(b,i)||f)&&d.is(":visible")){if(o&&h){var j=a(d.vars.asNavFor).data("flexslider");if(d.atEnd=0===b||b===d.count-1,j.flexAnimate(b,!0,!1,!0,i),d.direction=d.currentItem<b?"next":"prev",j.direction=d.direction,Math.ceil((b+1)/d.visible)-1===d.currentSlide||0===b)return d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),!1;d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),b=Math.floor(b/d.visible)}if(d.animating=!0,d.animatingTo=b,c&&d.pause(),d.vars.before(d),d.syncExists&&!i&&p.sync("animate"),d.vars.controlNav&&p.controlNav.active(),m||d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),d.atEnd=0===b||b===d.last,d.vars.directionNav&&p.directionNav.update(),b===d.last&&(d.vars.end(d),d.vars.animationLoop||d.pause()),n)g?(d.slides.eq(d.currentSlide).css({opacity:0,zIndex:1}),d.slides.eq(b).css({opacity:1,zIndex:2}),d.wrapup(q)):(d.slides.eq(d.currentSlide).css({zIndex:1}).animate({opacity:0},d.vars.animationSpeed,d.vars.easing),d.slides.eq(b).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing,d.wrapup));else{var r,s,t,q=k?d.slides.filter(":first").height():d.computedW;m?(r=d.vars.itemMargin,t=(d.itemW+r)*d.move*d.animatingTo,s=t>d.limit&&1!==d.visible?d.limit:t):s=0===d.currentSlide&&b===d.count-1&&d.vars.animationLoop&&"next"!==d.direction?l?(d.count+d.cloneOffset)*q:0:d.currentSlide===d.last&&0===b&&d.vars.animationLoop&&"prev"!==d.direction?l?0:(d.count+1)*q:l?(d.count-1-b+d.cloneOffset)*q:(b+d.cloneOffset)*q,d.setProps(s,"",d.vars.animationSpeed),d.transitions?(d.vars.animationLoop&&d.atEnd||(d.animating=!1,d.currentSlide=d.animatingTo),d.container.unbind("webkitTransitionEnd transitionend"),d.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(d.ensureAnimationEnd),d.wrapup(q)}),clearTimeout(d.ensureAnimationEnd),d.ensureAnimationEnd=setTimeout(function(){d.wrapup(q)},d.vars.animationSpeed+100)):d.container.animate(d.args,d.vars.animationSpeed,d.vars.easing,function(){d.wrapup(q)})}d.vars.smoothHeight&&p.smoothHeight(d.vars.animationSpeed)}},d.wrapup=function(a){n||m||(0===d.currentSlide&&d.animatingTo===d.last&&d.vars.animationLoop?d.setProps(a,"jumpEnd"):d.currentSlide===d.last&&0===d.animatingTo&&d.vars.animationLoop&&d.setProps(a,"jumpStart")),d.animating=!1,d.currentSlide=d.animatingTo,d.vars.after(d)},d.animateSlides=function(){!d.animating&&q&&d.flexAnimate(d.getTarget("next"))},d.pause=function(){clearInterval(d.animatedSlides),d.animatedSlides=null,d.playing=!1,d.vars.pausePlay&&p.pausePlay.update("play"),d.syncExists&&p.sync("pause")},d.play=function(){d.playing&&clearInterval(d.animatedSlides),d.animatedSlides=d.animatedSlides||setInterval(d.animateSlides,d.vars.slideshowSpeed),d.started=d.playing=!0,d.vars.pausePlay&&p.pausePlay.update("pause"),d.syncExists&&p.sync("play")},d.stop=function(){d.pause(),d.stopped=!0},d.canAdvance=function(a,b){var c=o?d.pagingCount-1:d.last;return b?!0:o&&d.currentItem===d.count-1&&0===a&&"prev"===d.direction?!0:o&&0===d.currentItem&&a===d.pagingCount-1&&"next"!==d.direction?!1:a!==d.currentSlide||o?d.vars.animationLoop?!0:d.atEnd&&0===d.currentSlide&&a===c&&"next"!==d.direction?!1:d.atEnd&&d.currentSlide===c&&0===a&&"next"===d.direction?!1:!0:!1},d.getTarget=function(a){return d.direction=a,"next"===a?d.currentSlide===d.last?0:d.currentSlide+1:0===d.currentSlide?d.last:d.currentSlide-1},d.setProps=function(a,b,c){var e=function(){var c=a?a:(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo,e=function(){if(m)return"setTouch"===b?a:l&&d.animatingTo===d.last?0:l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:d.animatingTo===d.last?d.limit:c;switch(b){case"setTotal":return l?(d.count-1-d.currentSlide+d.cloneOffset)*a:(d.currentSlide+d.cloneOffset)*a;case"setTouch":return l?a:a;case"jumpEnd":return l?a:d.count*a;case"jumpStart":return l?d.count*a:a;default:return a}}();return-1*e+"px"}();d.transitions&&(e=k?"translate3d(0,"+e+",0)":"translate3d("+e+",0,0)",c=void 0!==c?c/1e3+"s":"0s",d.container.css("-"+d.pfx+"-transition-duration",c),d.container.css("transition-duration",c)),d.args[d.prop]=e,(d.transitions||void 0===c)&&d.container.css(d.args),d.container.css("transform",e)},d.setup=function(b){if(n)d.slides.css({width:"100%","float":"left",marginRight:"-100%",position:"relative"}),"init"===b&&(g?d.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+d.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(d.currentSlide).css({opacity:1,zIndex:2}):d.slides.css({opacity:0,display:"block",zIndex:1}).eq(d.currentSlide).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing)),d.vars.smoothHeight&&p.smoothHeight();else{var c,f;"init"===b&&(d.viewport=a('<div class="'+e+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(d).append(d.container),d.cloneCount=0,d.cloneOffset=0,l&&(f=a.makeArray(d.slides).reverse(),d.slides=a(f),d.container.empty().append(d.slides))),d.vars.animationLoop&&!m&&(d.cloneCount=2,d.cloneOffset=1,"init"!==b&&d.container.find(".clone").remove(),p.uniqueID(d.slides.first().clone().addClass("clone").attr("aria-hidden","true")).appendTo(d.container),p.uniqueID(d.slides.last().clone().addClass("clone").attr("aria-hidden","true")).prependTo(d.container)),d.newSlides=a(d.vars.selector,d),c=l?d.count-1-d.currentSlide+d.cloneOffset:d.currentSlide+d.cloneOffset,k&&!m?(d.container.height(200*(d.count+d.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){d.newSlides.css({display:"block"}),d.doMath(),d.viewport.height(d.h),d.setProps(c*d.h,"init")},"init"===b?100:0)):(d.container.width(200*(d.count+d.cloneCount)+"%"),d.setProps(c*d.computedW,"init"),setTimeout(function(){d.doMath(),d.newSlides.css({width:d.computedW,"float":"left",display:"block"}),d.vars.smoothHeight&&p.smoothHeight()},"init"===b?100:0))}m||d.slides.removeClass(e+"active-slide").eq(d.currentSlide).addClass(e+"active-slide"),d.vars.init(d)},d.doMath=function(){var a=d.slides.first(),b=d.vars.itemMargin,c=d.vars.minItems,e=d.vars.maxItems;d.w=void 0===d.viewport?d.width():d.viewport.width(),d.h=a.height(),d.boxPadding=a.outerWidth()-a.width(),m?(d.itemT=d.vars.itemWidth+b,d.minW=c?c*d.itemT:d.w,d.maxW=e?e*d.itemT-b:d.w,d.itemW=d.minW>d.w?(d.w-b*(c-1))/c:d.maxW<d.w?(d.w-b*(e-1))/e:d.vars.itemWidth>d.w?d.w:d.vars.itemWidth,d.visible=Math.floor(d.w/d.itemW),d.move=d.vars.move>0&&d.vars.move<d.visible?d.vars.move:d.visible,d.pagingCount=Math.ceil((d.count-d.visible)/d.move+1),d.last=d.pagingCount-1,d.limit=1===d.pagingCount?0:d.vars.itemWidth>d.w?d.itemW*(d.count-1)+b*(d.count-1):(d.itemW+b)*d.count-d.w-b):(d.itemW=d.w,d.pagingCount=d.count,d.last=d.count-1),d.computedW=d.itemW-d.boxPadding},d.update=function(a,b){d.doMath(),m||(a<d.currentSlide?d.currentSlide+=1:a<=d.currentSlide&&0!==a&&(d.currentSlide-=1),d.animatingTo=d.currentSlide),d.vars.controlNav&&!d.manualControls&&("add"===b&&!m||d.pagingCount>d.controlNav.length?p.controlNav.update("add"):("remove"===b&&!m||d.pagingCount<d.controlNav.length)&&(m&&d.currentSlide>d.last&&(d.currentSlide-=1,d.animatingTo-=1),p.controlNav.update("remove",d.last))),d.vars.directionNav&&p.directionNav.update()},d.addSlide=function(b,c){var e=a(b);d.count+=1,d.last=d.count-1,k&&l?void 0!==c?d.slides.eq(d.count-c).after(e):d.container.prepend(e):void 0!==c?d.slides.eq(c).before(e):d.container.append(e),d.update(c,"add"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.added(d)},d.removeSlide=function(b){var c=isNaN(b)?d.slides.index(a(b)):b;d.count-=1,d.last=d.count-1,isNaN(b)?a(b,d.slides).remove():k&&l?d.slides.eq(d.last).remove():d.slides.eq(b).remove(),d.doMath(),d.update(c,"remove"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.removed(d)},p.init()},a(window).blur(function(){focused=!1}).focus(function(){focused=!0}),a.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){}},a.fn.flexslider=function(b){if(void 0===b&&(b={}),"object"==typeof b)return this.each(function(){var c=a(this),d=b.selector?b.selector:".slides > li",e=c.find(d);1===e.length&&b.allowOneSlide===!0||0===e.length?(e.fadeIn(400),b.start&&b.start(c)):void 0===c.data("flexslider")&&new a.flexslider(this,b)});var c=a(this).data("flexslider");switch(b){case"play":c.play();break;case"pause":c.pause();break;case"stop":c.stop();break;case"next":c.flexAnimate(c.getTarget("next"),!0);break;case"prev":case"previous":c.flexAnimate(c.getTarget("prev"),!0);break;default:"number"==typeof b&&c.flexAnimate(b,!0)}}}(jQuery);

/*!
	Zoom v1.7.13 - 2014-04-29
	Enlarge images on click or mouseover.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,m,l,r,s,f=o(t).css("position"),h=o(n);return t.style.position=/(absolute|fixed)/.test(f)?f:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=o(t).outerWidth(),u=o(t).outerHeight(),n===t?(m=c,a=u):(m=h.outerWidth(),a=h.outerHeight()),l=(e.width-c)/m,r=(e.height-u)/a,s=h.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,m),0),e.style.left=t*-l+"px",e.style.top=n*-r+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e,i=o.extend({},t,n||{}),u=i.target||this,c=this,a=o(c),m=document.createElement("img"),l=o(m),r="mousemove.zoom",s=!1,f=!1;(i.url||(e=a.find("img"),e[0]&&(i.url=e.data("src")||e.attr("src")),i.url))&&(function(){var o=u.style.position,t=u.style.overflow;a.one("zoom.destroy",function(){a.off(".zoom"),u.style.position=o,u.style.overflow=t,l.remove()})}(),m.onload=function(){function t(t){e.init(),e.move(t),l.stop().fadeTo(o.support.opacity?i.duration:0,1,o.isFunction(i.onZoomIn)?i.onZoomIn.call(m):!1)}function n(){l.stop().fadeTo(i.duration,0,o.isFunction(i.onZoomOut)?i.onZoomOut.call(m):!1)}var e=o.zoom(u,c,m,i.magnify);"grab"===i.on?a.on("mousedown.zoom",function(i){1===i.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(r,e.move)}),t(i),o(document).on(r,e.move),i.preventDefault())}):"click"===i.on?a.on("click.zoom",function(i){return s?void 0:(s=!0,t(i),o(document).on(r,e.move),o(document).one("click.zoom",function(){n(),s=!1,o(document).off(r,e.move)}),!1)}):"toggle"===i.on?a.on("click.zoom",function(o){s?n():t(o),s=!s}):"mouseover"===i.on&&(e.init(),a.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(r,e.move)),i.touch&&a.on("touchstart.zoom",function(o){o.preventDefault(),f?(f=!1,n()):(f=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),e.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}),o.isFunction(i.callback)&&i.callback.call(m)},m.src=i.url)})},o.fn.zoom.defaults=t})(window.jQuery);

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});


/*================ TIMBER ================*/
// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function() {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $window: $(window),

    // Navigation
    $navigation: $('#AccessibleNav')
  };
};

timber.init = function() {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.autoResponsiveElements();
};

timber.accessibleNav = function() {
  var classes = {
    active: 'nav-hover',
    focus: 'nav-focus',
    outside: 'nav-outside',
    hasDropdown: 'site-nav--has-dropdown'
  };
  var selectors = {
    active: '.nav-hover',
    hasDropdown: '.site-nav--has-dropdown',
    dropdown: '[data-meganav-dropdown]',
    link: '.site-nav__link',
    nextLink: '> .site-nav__link',
    parentLink: '[data-meganav-type="parent"]',
    childLink: '[data-meganav-type="child"]'
  };

  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find(selectors.link),
    $parents = $nav.find(selectors.hasDropdown),
    $childLinks = $nav.find(selectors.childLink),
    $topLevel = $parents.find(selectors.nextLink),
    $dropdowns = $nav.find(selectors.dropdown),
    $subMenuLinks = $dropdowns.find(selectors.link);

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
    var evtType = evt.type;
    var $dropdowns = $nav.find(selectors.active);

    if (!$el.hasClass(classes.active)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    // Make sure we close any opened same level dropdown before opening a new one
    if (evtType === 'touchstart' && $dropdowns.length > 0) {
      hideDropdown($el);
    }

    showDropdown($el);
  });

  $childLinks.on('touchstart', function(evt) {
    evt.stopImmediatePropagation();
  });

  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $allLinks.on('focus', function() {
    handleFocus($(this));
  });

  $allLinks.on('blur', function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $newFocus = null,
      $previousItem = $el.parent().prev();

    // Always put tabindex -1 on previous element just in case the user is going backward.
    // In that case, we want to focus on the previous parent and not the previous parent childs

    $allLinks.attr('tabindex', '');

    if ($previousItem.hasClass(classes.hasDropdown)) {
      $previousItem.find(selectors.dropdown + ' a').attr('tabindex', -1);
    }

    $newFocus = $el.parents(selectors.hasDropdown).find('> a');
    addFocus($newFocus);
  }

  function showDropdown($el) {
    var $toplevel = $el.find(selectors.nextLink);

    $toplevel.attr('aria-expanded', true);

    $el.addClass(classes.active);

    setTimeout(function() {
      timber.cache.$body.on('touchstart.MegaNav', function() {
        hideDropdowns();
      });
    }, 250);
  }

  function hideDropdown($el) {
    var $dropdowns = $el.parent().find(selectors.active);
    var $parentLink = $dropdowns.find(selectors.nextLink);

    $parentLink.attr('aria-expanded', false);

    $dropdowns.removeClass(classes.active);

    timber.cache.$body.off('touchstart.MegaNav');
  }

  function hideDropdowns() {
    var $dropdowns = $nav.find(selectors.active);
    $.each($dropdowns, function() {
      hideDropdown($(this));
    });
  }

  function addFocus($el) {
    $el.addClass(classes.focus);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', true);
    }
  }

  function removeFocus($el) {
    $el.removeClass(classes.focus);

    $subMenuLinks.attr('tabindex', -1);

    if ($el.attr('aria-expanded') !== undefined) {
      $el.attr('aria-expanded', false);
    }
  }

  // Check if dropdown is outside of viewport
  function handleDropdownOffset($dropdowns) {
    var viewportSize = $(window).width();
    $dropdowns.removeClass(classes.outside);

    $.each($dropdowns, function() {
      var $dropdown = $(this);
      var dropdownOffset = $dropdown.offset().left + $dropdown.width();
      if (dropdownOffset > viewportSize) {
        $dropdown.addClass(classes.outside);
      }
    });
  }

  timber.cache.$window.load(function() {
    handleDropdownOffset($dropdowns);
  });

  timber.cache.$window.resize(function() {
    afterResize(function() {
      handleDropdownOffset($dropdowns);
    }, 250);
  });
};

timber.autoResponsiveElements = function() {
  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's 'incorrect iFrame content on 'back'' bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Initialize Timber's JS on docready
$(timber.init);


/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 */

theme.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};


/* ================ MODULES ================ */
theme.Hero = (function() {
  theme.sliders = function(slider) {
    this.$slider = $(slider);
    this.sliderArgs = {
      animation: this.$slider.data('transition'),
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false,
      slideshow: this.$slider.data('autoplay'),
      slideshowSpeed: this.$slider.data('speed'),
      controlNav: this.$slider.data('show-dots'),
      smoothHeight: true,
      before: function(slider) {
        $(slider).resize();
        $(slider)
          .find('li')
          .not('.flex-active-slide')
          .removeClass('slide-hide');
      },
      after: function(slider) {
        $(slider)
          .find('li')
          .not('.flex-active-slide')
          .addClass('slide-hide');
        $(slider).resize();
      },
      start: function(slider) {
        $(slider)
          .find('li')
          .not('.flex-active-slide')
          .addClass('slide-hide');
      }
    };

    if (this.$slider.length) {
      if (this.$slider.find('li').length === 1) {
        this.sliderArgs.slideshow = false;
        this.sliderArgs.slideshowSpeed = 0;
        this.sliderArgs.controlNav = false;
        this.sliderArgs.directionNav = false;
        this.sliderArgs.touch = false;
      }

      return this.$slider.flexslider(this.sliderArgs);
    }
  };

  return theme.sliders;
})();


/*================ SECTIONS ================*/
theme.Product = (function() {
  function Product(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');

    this.selectors = {
      $html: $('html'),
      $productImageGallery: $('.gallery__item', this.$container),
      $productImages: $('.product-single__image-wrapper', this.$container),
      $thumbImages: $('#ProductThumbs', this.$container).find(
        'a.product-single__thumbnail'
      ),
      $productGridImages: $('.grid-link__image--product', this.$container),
      $addToCart: $('#AddToCart', this.$container),
      $productPrice: $('#ProductPrice', this.$container),
      $comparePrice: $('#ComparePrice', this.$container),
      $comparePriceA11y: $('#ComparePriceA11y', this.$container),
      $priceA11y: $('#PriceA11y', this.$container),
      $quantityElements: $('.product-single__quantity', this.$container),
      $addToCartText: $('#AddToCartText', this.$container),
      $tabTrigger: $('.tab-switch__trigger', this.$container),
      $tabContent: $('.tab-switch__content', this.$container),
      $productFullDetails: $('.product-single__full-details', this.$container),
      $SKU: $('.variant-sku', this.$container),
      $shopifyPaymentButton: $('.shopify-payment-button', this.$container)
    };

    if (!$('#ProductJson-' + this.sectionId).html()) {
      return;
    }

    this.zoomType = this.$container.data('image-zoom-type');
    this.showExtraTab = this.$container.data('show-extra-tab') || false;
    this.extraTabContent = this.$container.data('extra-tab-content') || '';
    this.relatedEnabled = this.$container.data('related-enabled') || false;
    this.enableHistoryState =
      this.$container.data('enable-history-state') || false;
    this.$productGridImages = $(
      this.selectors.productGridImages,
      this.$container
    );

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + this.sectionId).innerHTML
    );

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initBreakpoints();
      this.initProductVariant();
      this.productImageSwitch();
      timber.autoResponsiveElements();

      if (this.zoomType === 'lightbox') {
        this.productImageGallery();
      } else if (this.zoomType === 'zoom-in') {
        this.productImageZoom();
      }

      if (!this.showExtraTab || this.extraTabContent) {
        this.initProductTabs();
      }

      if (this.relatedEnabled) {
        theme.cacheSelectors();
        theme.equalHeights(this.selectors.$productGridImages);
      }
    },

    initBreakpoints: function() {
      var self = this;

      if (!this.selectors.$html.hasClass('lt-ie9')) {
        enquire.register(theme.variables.mediaQueryMedium, {
          match: function() {
            if (self.zoomType === 'zoom-in') {
              if (self.selectors.$productImages.length) {
                // remove event handlers for product zoom on mobile
                self.selectors.$productImages.trigger('zoom.destroy');
                self.selectors.$productImages.off();
                self.selectors.$productImages.removeClass('image-zoom');
              }
            } else if (self.zoomType === 'lightbox') {
              // remove event handlers for lightbox on mobile
              self.selectors.$productImageGallery.off();
              self.selectors.$productImages.each(function() {
                $(this).removeClass('zoom-lightbox');
              });
            }

            theme.variables.bpSmall = true;
          },
          unmatch: function() {
            theme.variables.bpSmall = false;
            if (self.zoomType === 'zoom-in') {
              // reinit product zoom
              self.productImageZoom();
            } else if (self.zoomType === 'lightbox') {
              // reinit lightbox
              self.selectors.$productImages.each(function() {
                $(this).addClass('zoom-lightbox');
              });
              self.productImageGallery();
            }
          }
        });
      }
    },

    productImageGallery: function() {
      if (theme.variables.bpSmall) return;

      if (!this.selectors.$productImageGallery.length) return;

      this.selectors.$productImageGallery.magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: theme.strings.zoomClose,
        removalDelay: 500,
        callbacks: {
          open: function() {
            $('html').css('overflow-y', 'hidden');
          },
          close: function() {
            $('html').css('overflow-y', '');
          }
        },
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          arrowMarkup:
            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: theme.strings.zoomPrev,
          tNext: theme.strings.zoomNext
        }
      });

      var $productImageGallery = this.selectors.$productImageGallery;
      this.selectors.$productImages.each(function() {
        $(this).bind('click', function() {
          var imageId = $(this).attr('data-image-id');
          $productImageGallery
            .filter('[data-image-id="' + imageId + '"]')
            .trigger('click');
        });
      });
    },

    productImageSwitch: function() {
      if (!this.selectors.$thumbImages.length) {
        return;
      }

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      this.selectors.$thumbImages.on('click', function(evt) {
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        self.switchImage(newImageId);
      });
    },

    initProductTabs: function() {
      if (!this.selectors.$tabTrigger.length) {
        return;
      }

      var $trigger = this.selectors.$tabTrigger,
        $content = this.selectors.$tabContent,
        $el,
        link;

      // Hide extra content areas with JS and set active tab
      $content.filter(':gt(0)').addClass('is-hidden');
      $trigger.first().addClass('is-active');

      $trigger.on('click', function(evt) {
        evt.preventDefault();
        // set active tab
        $trigger.removeClass('is-active');
        $el = $(this).addClass('is-active');

        // hide all content areas, then show desired one
        link = $el.data('link');
        $content.addClass('is-hidden');
        $content
          .filter('[data-content="' + link + '"]')
          .removeClass('is-hidden');
      });
    },

    initProductVariant: function() {
      var self = this;
      var product = this.productSingleObject;

      var selectCallback = function(variant, selector) {
        self.productPage({
          money_format: theme.moneyFormat,
          variant: variant,
          selector: selector,
          translations: {
            add_to_cart: theme.strings.addToCart,
            sold_out: theme.strings.soldOut,
            unavailable: theme.strings.unavailable
          }
        });
      };

      this.optionSelector = new Shopify.OptionSelectors(
        'ProductSelect-' + this.sectionId,
        {
          product: product,
          onVariantSelected: selectCallback,
          enableHistoryState: this.enableHistoryState
        }
      );

      // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
      if (product.options.length === 1 && product.options[0] !== 'Title') {
        $('.selector-wrapper:eq(0)', this.$container).prepend(
          '<label for="productSelect-option-0">' +
            product.options[0] +
            '</label>'
        );
      }

      // Hide selectors if we only have 1 variant and its title contains 'Default'.
      if (
        product.variants.length === 1 &&
        product.variants[0].title.toLowerCase().indexOf('default') !== -1
      ) {
        $('.selector-wrapper', this.$container).hide();
      }
    },

    productPage: function(options) {
      var self = this;
      var moneyFormat = options.money_format;
      var variant = options.variant;
      var translations = options.translations;

      if (variant) {
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image;
          self.switchImage(newImg.id);
        }

        // Select a valid variant if available
        if (variant.available) {
          // Available, enable the submit button, change text, show quantity elements
          this.selectors.$addToCart
            .removeClass('disabled')
            .prop('disabled', false);
          this.selectors.$addToCartText.html(translations.add_to_cart);
          this.selectors.$quantityElements.show();
          this.selectors.$shopifyPaymentButton.show();

          var $link = $(this.selectors.$productFullDetails, this.$container);

          if ($link.length) {
            $link.attr(
              'href',
              this.updateUrlParameter($link.attr('href'), 'variant', variant.id)
            );
          }
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          this.selectors.$addToCart.addClass('disabled').prop('disabled', true);
          this.selectors.$addToCartText.html(translations.sold_out);
          this.selectors.$quantityElements.hide();
          this.selectors.$shopifyPaymentButton.hide();
        }

        // Regardless of stock, update the product price
        this.selectors.$productPrice.html(
          Shopify.formatMoney(variant.price, moneyFormat)
        );

        var l = Shopify.formatMoney(variant.price, moneyFormat).substring(1);
        this.selectors.$productPrice.attr('content', parseFloat(l));
        
        // Show SKU
        this.selectors.$SKU.html(variant.sku);

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          this.selectors.$comparePrice
            .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
            .removeClass('hide');
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'false');
          this.selectors.$priceA11y.attr('aria-hidden', 'false');
        } else {
          this.selectors.$comparePrice.addClass('hide').html('');
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'true');
        }
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        this.selectors.$addToCart.addClass('disabled').prop('disabled', true);
        this.selectors.$addToCartText.html(translations.unavailable);
        this.selectors.$quantityElements.hide();
        this.selectors.$shopifyPaymentButton.hide();
      }
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.$productImages.selector +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.$productImages.selector +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    productImageZoom: function() {
      if (theme.variables.bpSmall && this.zoomType !== 'zoom-in') return;

      if (
        !this.selectors.$productImages.length ||
        this.selectors.$html.hasClass('supports-touch')
      )
        return;

      // Destroy zoom (in case it was already set), then set it up again
      this.selectors.$productImages.trigger('zoom.destroy');

      this.selectors.$productImages.each(function() {
        $(this)
          .addClass('image-zoom')
          .zoom({
            url: $(this)
              .find('img')
              .attr('data-zoom')
          });
      });
    }
  });

  return Product;
})();

theme.Collection = (function() {
  function Collection(container) {
    this.$container = $(container);

    this.selectors = {
      productGridImages: '.grid-link__image--product'
    };

    this.sortEnabled = this.$container.data('sort-enabled');
    this.tagsEnabled = this.$container.data('tags-enabled');

    this.$productGridImages = $(
      this.selectors.productGridImages,
      this.$container
    );

    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function() {
      this.stringOverrides();
      theme.cacheSelectors();
      theme.equalHeights(this.$productGridImages);

      if (this.sortEnabled) {
        this.collectionSorting();
      }

      if (this.tagsEnabled) {
        this.collectionTags();
      }
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    collectionSorting: function() {
      /*============================================================================
        Initialised here because collection liquid object is only available
        on collection pages, and not external JS files
      ==============================================================================*/
      Shopify.queryParams = {};
      if (location.search.length && location.search.indexOf('sort_by')) {
        for (
          var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
          i < aCouples.length;
          i++
        ) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $(function() {
        $('#SortBy')
          .val(theme.strings.sortBy)
          .bind('change', function() {
            Shopify.queryParams.sort_by = $(this).val();
            location.search = $.param(Shopify.queryParams);
          });
      });
    },

    collectionTags: function() {
      var $browseBy = $('#BrowseBy');
      $(function() {
        $browseBy.bind('change', function() {
          location.href = $browseBy.val();
        });
      });
    }
  });

  return Collection;
})();

theme.ListCollections = (function() {
  function ListCollections(container) {
    this.$container = $(container);

    this.selectors = {
      collectionGridImages: '.grid-link__image--collection'
    };

    this.$collectionGridImages = $(
      this.selectors.collectionGridImages,
      this.$container
    );

    this.init();
  }

  ListCollections.prototype = _.assignIn({}, ListCollections.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.$collectionGridImages);
    }
  });

  return ListCollections;
})();

theme.Cart = (function() {
  var selectors = {
    body: 'body',
    cartSection: '#CartSection',
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart() {
    if (!cookiesEnabled()) {
      $(selectors.cartSection).addClass(selectors.cartNoCookies);
    }

    if (!$(selectors.cartSection).data('notes-enable')) {
      return;
    }

    $(selectors.body).on('click', selectors.cartNoteAdd, function() {
      $(this).addClass('is-hidden');
      $(selectors.cartNote).addClass('is-active');
    });
  }

  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }

  return Cart;
})();

theme.Header = (function() {
  function Header() {
    this.selectors = {
      headerBar: '.header-bar',
      mobileNavTrigger: '#MobileNavTrigger',
      mobileNav: '#MobileNav',
      mobileSublistTrigger: '.mobile-nav__sublist-trigger',
      showDropdownClass: 'show-dropdown',
      hasDropdownItem: '.site-nav--has-dropdown'
    };

    this.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    init: function() {
      var self = this;

      this.cacheSelectors();

      cache.$mobileNavTrigger.on('click.mobileNavTrigger', function(evt) {
        evt.preventDefault();

        var isExpanded = $(this).attr('aria-expanded');

        if (isExpanded === 'true') {
          self.menuClose();
        } else {
          self.menuOpen();
        }
      });

      cache.$mobileSublistTrigger.on('click.mobileSublistTrigger', function(
        evt
      ) {
        var $el = $(this);
        var isExpanded = $el.attr('aria-expanded') === 'true';
        // Enable commented out if statement to allow direct clicking on trigger link
        //if (!$el.hasClass('is-active')) {
        evt.preventDefault();

        $el
          .toggleClass('is-active')
          .next('.mobile-nav__sublist')
          .stop()
          .slideToggle(200);

        $el.attr('aria-expanded', !isExpanded);

        if (
          !$el.hasClass(self.selectors.showDropdownClass) &&
          timber.vars.isTouch
        ) {
          evt.preventDefault();
          $el.addClass(self.selectors.showDropdownClass);
          cache.$doc.on('click.mobileNav', handleClickOutsideDropdown);
        }

        function handleClickOutsideDropdown(evt) {
          var $target = $(evt.target);

          if (!$target.is($el) && !$.contains($el[0], $target[0])) {
            $el.removeClass(self.selectors.showDropdownClass);
            cache.$doc.off('.mobileNav');
          }
        }
      });
    },

    cacheSelectors: function() {
      window.cache = window.cache || {};
      $.extend(window.cache, {
        $doc: $(document),
        $headerBar: $(this.selectors.headerBar),
        $mobileNavTrigger: $(this.selectors.mobileNavTrigger),
        $mobileNav: $(this.selectors.mobileNav),
        $mobileSublistTrigger: $(this.selectors.mobileSublistTrigger),
        $hasDropdownItem: $(this.selectors.hasDropdownItem)
      });
    },

    onUnload: function() {
      cache.$mobileNavTrigger.off('.mobileNavTrigger');
      cache.$mobileSublistTrigger.off('.mobileSublistTrigger');
    },

    menuOpen: function() {
      var self = this;

      cache.$mobileNavTrigger.attr('aria-expanded', 'true');
      cache.$mobileNav.slideDown(220);

      theme.a11y.trapFocus({
        $container: cache.$headerBar,
        $elementToFocus: cache.$mobileNav.find('> li:first-child a'),
        namespace: 'drawerMenu'
      });

      // Escape key closes menu
      theme.cache.$html.on('keyup.drawerMenu', function(evt) {
        if (evt.keyCode === 27) {
          self.menuClose();
        }
      });
    },

    menuClose: function() {
      cache.$mobileNavTrigger.attr('aria-expanded', 'false');
      cache.$mobileNav.slideUp(220);
      theme.cache.$html.off('keyup.drawerMenu');

      theme.a11y.removeTrapFocus({
        $container: cache.$headerBar,
        namespace: 'drawerMenu'
      });
    }
  });

  return Header;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    this.$container = $(container);
    var id = this.$container.attr('data-section-id');
    var slideshow = (this.slideshow = '#flexslider--' + id);

    theme.slideshows[slideshow] = new theme.Hero(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $('#slide--' + evt.detail.blockId + ':not(.clone)');
      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img');
      $slideshow.flexslider(slideIndex, true);

      $slideImg.on('load', function() {
        var intervalAttempts = 0;

        // Needed to resize the slider as the on('load') listener doesn't wait until the image has loaded.
        var imageHeightCheck = setInterval(function() {
          intervalAttempts++;
          if (
            $slideImg.length &&
            $slideImg.height() === 0 &&
            intervalAttempts < 10
          ) {
            sizeSlideshow($slideshow);
          } else {
            // clear interval
            sizeSlideshow($slideshow);
            clearInterval(imageHeightCheck);
          }
        }, 500);
      });

      function sizeSlideshow($slideshow) {
        $slideshow.resize();
      }
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).flexslider('play');
    }
  }
);

theme.CollectionList = (function() {
  function CollectionList(container) {
    this.$container = $(container);

    this.selectors = {
      collectionGridImages: '.grid-link__image--collection'
    };

    this.$collectionGridImages = $(
      this.selectors.collectionGridImages,
      this.$container
    );

    this.init();
  }

  CollectionList.prototype = _.assignIn({}, CollectionList.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.$collectionGridImages);
    }
  });

  return CollectionList;
})();

theme.FeaturedProducts = (function() {
  function FeaturedProducts(container) {
    this.$container = $(container);

    this.selectors = {
      productGridImages: '.grid-link__image--product'
    };

    this.$productGridImages = $(
      this.selectors.productGridImages,
      this.$container
    );

    this.init();
  }

  FeaturedProducts.prototype = _.assignIn({}, FeaturedProducts.prototype, {
    init: function() {
      theme.cacheSelectors();
      theme.equalHeights(this.$productGridImages);
    }
  });

  return FeaturedProducts;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    theme.$currentMapContainer = this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents('.map-section');

            $mapContainer.addClass('page-width map-section--load-error');
            $mapContainer
              .find('.map-section__wrapper')
              .html(
                '<div class="errors text-center">' + errorMessage + '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  if (!Shopify.designMode) return;

  theme.$currentMapContainer.addClass('page-width map-section--load-error');
  theme.$currentMapContainer
    .find('.map-section__wrapper')
    .html(
      '<div class="errors text-center">' + theme.strings.authError + '</div>'
    );
}

window.theme = window.theme || {};

theme.PasswordHeader = (function() {
  function PasswordHeader() {
    this.init();
  }

  PasswordHeader.prototype = _.assignIn({}, PasswordHeader.prototype, {
    init: function() {
      $('.js-toggle-login-modal').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: password.strings.pageClose,
        removalDelay: 500,
        callbacks: {
          open: function() {
            window.setTimeout(function() {
              document.getElementById('password').focus();
            }, 50);
          }
        }
      });
      if ($('.storefront-password-form .errors').size()) {
        $('.js-toggle-login-modal').click();
      }
    }
  });

  return PasswordHeader;
})();


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('cart-template', theme.Cart);
  sections.register('article-template', theme.Article);
  sections.register('header-section', theme.Header);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('collection-list-section', theme.CollectionList);
  sections.register('featured-products-section', theme.FeaturedProducts);
  sections.register('map-section', theme.Maps);
  sections.register('password-header', theme.PasswordHeader);
});

theme.cacheSelectors = function() {
  theme.cache = {
    // General
    $w: $(window),
    $html: $('html')
  };
};

timber.cacheVariables = function() {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  };
};

theme.init = function() {
  theme.cacheSelectors();
  timber.cacheVariables();
};

theme.equalHeights = function($selector) {
  theme.cache.$w.on('load', resizeElements($selector));

  theme.cache.$w.on(
    'resize',
    afterResize(
      function() {
        resizeElements($selector);
      },
      250,
      'equal-heights'
    )
  );

  function resizeElements($selector) {
    $selector.imagesLoaded(function() {
      $selector.css('height', 'auto').equalHeights();
    });
  }
};

// Initialize theme's JS on docready
$(theme.init);

var TheDatepicker;
(function (TheDatepicker) {
  var Translator = (function () {
    function Translator() {
      this.dayOfWeekTranslations = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa',];
      this.monthTranslations = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',];
    }

    Translator.prototype.setDayOfWeekTranslation = function (dayOfWeek, translation) {
      dayOfWeek = TheDatepicker.Helper.checkNumber('First day of week', dayOfWeek);
      TheDatepicker.Helper.checkString('Translation', translation);
      if (dayOfWeek < 0 || dayOfWeek > 6) {
        throw new Error('Day of week was expected to be a number from 0 to 6.');
      }
      this.dayOfWeekTranslations[dayOfWeek] = translation;
    };
    Translator.prototype.setMonthTranslation = function (month, translation) {
      month = TheDatepicker.Helper.checkNumber('Month', month);
      TheDatepicker.Helper.checkString('Translation', translation);
      if (month < 0 || month > 11) {
        throw new Error('Month was expected to be a number from 0 to 11.');
      }
      this.monthTranslations[month] = translation;
    };
    Translator.prototype.translateDayOfWeek = function (dayOfWeek) {
      return this.dayOfWeekTranslations[dayOfWeek];
    };
    Translator.prototype.translateMonth = function (month) {
      return this.monthTranslations[month];
    };
    return Translator;
  }());
  TheDatepicker.Translator = Translator;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var CannotParseDateException = (function () {
    function CannotParseDateException() {
    }

    return CannotParseDateException;
  }());
  TheDatepicker.CannotParseDateException = CannotParseDateException;
  var DateConverter = (function () {
    function DateConverter(translator) {
      this.translator = translator;
      this.escapeChar = '\\';
    }

    DateConverter.prototype.formatDate = function (format, date) {
      var escapeNext = false;
      var result = '';
      for (var position = 0; position < format.length; position++) {
        var char = format.substring(position, position + 1);
        if (escapeNext) {
          result += char;
          escapeNext = false;
          continue;
        }
        if (char === this.escapeChar) {
          escapeNext = true;
          continue;
        }
        var formatter = this.getFormatter(char);
        if (formatter !== null) {
          result += formatter.call(this, date);
          continue;
        }
        result += char;
      }
      return result;
    };
    DateConverter.prototype.parseDate = function (format, text) {
      if (text === '') {
        return null;
      }
      var date = new Date();
      var escapeNext = false;
      var textPosition = 0;
      for (var position = 0; position < format.length; position++) {
        var char = format.substring(position, position + 1);
        if (escapeNext) {
          escapeNext = false;
        } else if (char === this.escapeChar) {
          escapeNext = true;
          continue;
        } else {
          var parser = this.getParser(char);
          if (parser !== null) {
            try {
              textPosition += parser.call(this, text.substring(textPosition), date);
            } catch (error) {
              if (!(error instanceof CannotParseDateException)) {
                throw error;
              }
              var textChar_1 = text.substring(textPosition, textPosition + 1);
              if (textChar_1 === ' ') {
                textPosition++;
                position--;
                continue;
              } else {
                throw error;
              }
            }
            if (isNaN(date.getTime())) {
              throw new CannotParseDateException();
            }
            continue;
          }
        }
        var textChar = text.substring(textPosition, textPosition + 1);
        if (textChar !== char) {
          if (char === ' ') {
            continue;
          }
          if (textChar === ' ') {
            textPosition++;
            position--;
            continue;
          }
          throw new CannotParseDateException();
        }
        textPosition++;
      }
      return date;
    };
    DateConverter.prototype.getFormatter = function (type) {
      switch (type) {
        case 'j':
          return this.formatDay;
        case 'd':
          return this.formatDayWithLeadingZero;
        case 'D':
          return this.formatDayOfWeekTextual;
        case 'n':
          return this.formatMonth;
        case 'm':
          return this.formatMonthWithLeadingZero;
        case 'F':
          return this.formatMonthTextual;
        case 'Y':
          return this.formatYear;
        case 'y':
          return this.formatYearTwoDigits;
        default:
          return null;
      }
    };
    DateConverter.prototype.formatDay = function (date) {
      return date.getDate().toString();
    };
    DateConverter.prototype.formatDayWithLeadingZero = function (date) {
      var day = date.getDate().toString();
      if (day.length === 1) {
        day = '0' + day;
      }
      return day;
    };
    DateConverter.prototype.formatDayOfWeekTextual = function (date) {
      return this.translator.translateDayOfWeek(date.getDay());
    };
    DateConverter.prototype.formatMonth = function (date) {
      return (date.getMonth() + 1).toString();
    };
    DateConverter.prototype.formatMonthWithLeadingZero = function (date) {
      var month = (date.getMonth() + 1).toString();
      if (month.length === 1) {
        month = '0' + month;
      }
      return month;
    };
    DateConverter.prototype.formatMonthTextual = function (date) {
      return this.translator.translateMonth(date.getMonth());
    };
    DateConverter.prototype.formatYear = function (date) {
      return date.getFullYear().toString();
    };
    DateConverter.prototype.formatYearTwoDigits = function (date) {
      var year = date.getFullYear().toString();
      return year.substring(year.length - 2);
    };
    DateConverter.prototype.getParser = function (type) {
      switch (type) {
        case 'j':
        case 'd':
          return this.parseDay;
        case 'D':
          return this.parseDayOfWeekTextual;
        case 'n':
        case 'm':
          return this.parseMonth;
        case 'F':
          return this.parseMonthTextual;
        case 'Y':
          return this.parseYear;
        case 'y':
          return this.parseYearTwoDigits;
        default:
          return null;
      }
    };
    DateConverter.prototype.parseDay = function (text, date) {
      var took = 0;
      while (text.substring(0, 1) === '0') {
        text = text.substring(1);
        took++;
      }
      var day = text.substring(0, 2);
      if (!/[12][0-9]|3[01]/.test(day)) {
        day = day.substring(0, 1);
        if (!/[1-9]/.test(day)) {
          throw new CannotParseDateException();
        }
      }
      date.setDate(parseInt(day, 10));
      return took + day.length;
    };
    DateConverter.prototype.parseDayOfWeekTextual = function (text, date) {
      var maxLength = 0;
      for (var dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        var translation = this.translator.translateDayOfWeek(dayOfWeek);
        maxLength = Math.max(maxLength, translation.length);
        if (text.substring(0, translation.length).toLowerCase() === translation.toLowerCase()) {
          return translation.length;
        }
      }
      var took = 0;
      while (/[a-zA-Z]/.test(text.substring(0, 1))) {
        text = text.substring(1);
        took++;
        if (took === maxLength) {
          break;
        }
      }
      return took;
    };
    DateConverter.prototype.parseMonth = function (text, date) {
      var took = 0;
      while (text.substring(0, 1) === '0') {
        text = text.substring(1);
        took++;
      }
      var month = text.substring(0, 2);
      if (month !== '10' && month !== '11' && month !== '12') {
        month = month.substring(0, 1);
        if (!/[1-9]/.test(month)) {
          throw new CannotParseDateException();
        }
      }
      date.setMonth(parseInt(month, 10) - 1);
      return took + month.length;
    };
    DateConverter.prototype.parseMonthTextual = function (text, date) {
      for (var month = 0; month < 12; month++) {
        var translation = this.translator.translateMonth(month);
        if (text.substring(0, translation.length).toLowerCase() === translation.toLowerCase()) {
          date.setMonth(month);
          return translation.length;
        }
      }
      throw new CannotParseDateException();
    };
    DateConverter.prototype.parseYear = function (text, date) {
      var isNegative = false;
      if (text.substring(0, 1) === '-') {
        isNegative = true;
        text = text.substring(1);
      }
      var yearLength = 0;
      while (/[0-9]/.test(text.substring(yearLength, yearLength + 1))) {
        yearLength++;
      }
      if (yearLength === 0) {
        throw new CannotParseDateException();
      }
      var year = parseInt(text.substring(0, yearLength), 10);
      if (isNegative) {
        year = -year;
      }
      date.setFullYear(year);
      return yearLength + (isNegative ? 1 : 0);
    };
    DateConverter.prototype.parseYearTwoDigits = function (text, date) {
      var yearEnd = text.substring(0, 2);
      if (!/[0-9]{2}/.test(yearEnd)) {
        throw new CannotParseDateException();
      }
      var currentYear = (new Date()).getFullYear().toString();
      var yearBeginning = currentYear.substring(0, currentYear.length - 2);
      date.setFullYear(parseInt(yearBeginning + yearEnd, 10));
      return 2;
    };
    return DateConverter;
  }());
  TheDatepicker.DateConverter = DateConverter;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var InitializationPhase;
  (function (InitializationPhase) {
    InitializationPhase[InitializationPhase["Untouched"] = 0] = "Untouched";
    InitializationPhase[InitializationPhase["Waiting"] = 1] = "Waiting";
    InitializationPhase[InitializationPhase["Ready"] = 2] = "Ready";
    InitializationPhase[InitializationPhase["Initialized"] = 3] = "Initialized";
    InitializationPhase[InitializationPhase["Destroyed"] = 4] = "Destroyed";
  })(InitializationPhase || (InitializationPhase = {}));
  var Datepicker = (function () {
    function Datepicker(input, container) {
      if (container === void 0) {
        container = null;
      }
      this.initializationPhase = InitializationPhase.Untouched;
      this.inputListenerRemover = null;
      this.listenerRemovers = [];
      this.deselectElement = null;
      if (input !== null && !TheDatepicker.Helper.isElement(input)) {
        throw new Error('Input was expected to be null or an HTMLElement.');
      }
      if (container !== null && !TheDatepicker.Helper.isElement(container)) {
        throw new Error('Container was expected to be null or an HTMLElement.');
      }
      if (input === null && container === null) {
        throw new Error('At least one of input or container is mandatory.');
      }
      this.document = document;
      var duplicateError = 'There is already a datepicker present on ';
      this.isContainerExternal = container !== null;
      if (container === null) {
        container = this.createContainer();
        if (input !== null) {
          input.parentNode.insertBefore(container, input.nextSibling);
        }
      } else {
        if (typeof container.datepicker !== 'undefined') {
          throw new Error(duplicateError + 'container.');
        }
      }
      if (input !== null) {
        if (typeof input.datepicker !== 'undefined') {
          throw new Error(duplicateError + 'input.');
        }
        input.datepicker = this;
        input.autocomplete = 'off';
      }
      container.datepicker = this;
      this.input = input;
      this.container = container;
      this.options = new TheDatepicker.Options();
      this.dateConverter = new TheDatepicker.DateConverter(this.options.translator);
      this.viewModel = new TheDatepicker.ViewModel(this.options, this);
    }

    Datepicker.prototype.render = function () {
      var _this = this;
      switch (this.initializationPhase) {
        case InitializationPhase.Destroyed:
          return;
        case InitializationPhase.Initialized:
          this.viewModel.render();
          return;
        case InitializationPhase.Ready:
          this.initListeners();
          this.initializationPhase = InitializationPhase.Initialized;
          this.render();
          return;
        case InitializationPhase.Waiting:
          if (!this.options.isHiddenOnBlur()) {
            this.open();
            return;
          }
          this.updateDeselectButton();
          if (this.viewModel.selectedDate !== null && (!this.options.isDateInValidity(this.viewModel.selectedDate) || !this.options.isDateAvailable(this.viewModel.selectedDate))) {
            this.viewModel.cancelSelection(null);
          } else if (this.viewModel.selectedDate == null && !this.options.isAllowedEmpty()) {
            this.viewModel.selectDay(null, this.options.getInitialDate(), false);
          }
          return;
        case InitializationPhase.Untouched:
          this.preselectFromInput();
          this.createDeselectElement();
          this.viewModel.selectDay(null, this.options.getInitialDate(), false);
          this.updateInput();
          if (this.input !== null && this.options.isHiddenOnBlur()) {
            if (this.input === this.document.activeElement) {
              this.initializationPhase = InitializationPhase.Ready;
              this.render();
              this.open();
              return;
            }
            this.inputListenerRemover = TheDatepicker.Helper.addEventListener(this.input, TheDatepicker.ListenerType.Focus, function (event) {
              _this.open(event);
            });
            this.initializationPhase = InitializationPhase.Waiting;
            return;
          }
          this.initializationPhase = InitializationPhase.Ready;
          this.render();
      }
    };
    Datepicker.prototype.open = function (event) {
      if (event === void 0) {
        event = null;
      }
      if (this.initializationPhase === InitializationPhase.Untouched) {
        this.render();
      }
      if (this.initializationPhase === InitializationPhase.Waiting) {
        this.initializationPhase = InitializationPhase.Ready;
        this.render();
        Datepicker.hasClickedViewModel = true;
      }
      if (!Datepicker.activateViewModel(event, this.viewModel)) {
        return false;
      }
      if (this.input !== null) {
        this.input.focus();
      }
      return true;
    };
    Datepicker.prototype.close = function (event) {
      if (event === void 0) {
        event = null;
      }
      if (!this.viewModel.isActive()) {
        return true;
      }
      if (!Datepicker.activateViewModel(event, null)) {
        return false;
      }
      if (this.input !== null) {
        this.input.blur();
      }
      return true;
    };
    Datepicker.prototype.reset = function (event) {
      if (event === void 0) {
        event = null;
      }
      return this.viewModel.reset(event);
    };
    Datepicker.prototype.destroy = function () {
      if (this.initializationPhase === InitializationPhase.Destroyed) {
        return;
      }
      for (var index = 0; index < this.listenerRemovers.length; index++) {
        this.listenerRemovers[index]();
      }
      this.listenerRemovers = [];
      if (this.isContainerExternal) {
        this.container.innerHTML = '';
      } else {
        this.container.parentNode.removeChild(this.container);
      }
      this.container.datepicker = null;
      if (this.input !== null) {
        this.input.datepicker = null;
        this.removeInitialInputListener();
        this.input = null;
      }
      if (this.deselectElement !== null) {
        this.deselectElement.parentNode.removeChild(this.deselectElement);
        this.deselectElement = null;
      }
      this.initializationPhase = InitializationPhase.Destroyed;
    };
    Datepicker.prototype.selectDate = function (date, doUpdateMonth, event) {
      if (doUpdateMonth === void 0) {
        doUpdateMonth = true;
      }
      if (event === void 0) {
        event = null;
      }
      return this.viewModel.selectDay(event, TheDatepicker.Helper.normalizeDate('Date', date), doUpdateMonth);
    };
    Datepicker.prototype.getSelectedDate = function () {
      return this.viewModel.selectedDate;
    };
    Datepicker.prototype.goToMonth = function (month, event) {
      if (event === void 0) {
        event = null;
      }
      return this.viewModel.goToMonth(event, TheDatepicker.Helper.normalizeDate('Month', month));
    };
    Datepicker.prototype.readInput = function (event) {
      if (event === void 0) {
        event = null;
      }
      if (this.input === null) {
        return false;
      }
      try {
        var date = this.dateConverter.parseDate(this.options.getInputFormat(), this.input.value);
        if (date !== null) {
          return this.viewModel.selectDateSince(event, date);
        }
        return this.viewModel.cancelSelection(event);
      } catch (error) {
        if (!(error instanceof TheDatepicker.CannotParseDateException)) {
          throw error;
        }
        return false;
      }
    };
    Datepicker.prototype.updateInput = function () {
      if (this.input === null || this.input === this.document.activeElement) {
        return;
      }
      this.input.value = this.viewModel.selectedDate !== null ? this.dateConverter.formatDate(this.options.getInputFormat(), this.viewModel.selectedDate) : '';
      this.updateDeselectButton();
    };
    Datepicker.prototype.createContainer = function () {
      var container = this.document.createElement('div');
      container.style.position = 'absolute';
      container.style.zIndex = '99';
      return container;
    };
    Datepicker.prototype.createDeselectElement = function () {
      var _this = this;
      if (this.input === null || !this.options.isDeselectButtonShown() || !this.options.isAllowedEmpty()) {
        return null;
      }
      var deselectElement = this.document.createElement('span');
      deselectElement.style.position = 'absolute';
      var deselectButton = this.document.createElement('a');
      deselectButton.innerHTML = this.options.getDeselectHtml();
      deselectButton.style.position = 'relative';
      deselectButton.style.left = '-12px';
      deselectButton.href = '#';
      deselectButton.onclick = function (event) {
        event = event || window.event;
        TheDatepicker.Helper.preventDefault(event);
        _this.viewModel.cancelSelection(event);
      };
      deselectElement.className = this.options.getClassesPrefix() + 'deselect';
      deselectElement.appendChild(deselectButton);
      this.input.parentNode.insertBefore(deselectElement, this.input.nextSibling);
      this.deselectElement = deselectElement;
    };
    Datepicker.prototype.updateDeselectButton = function () {
      if (this.input !== null && this.deselectElement !== null) {
        var isVisible = this.options.isDeselectButtonShown() && this.options.isAllowedEmpty() && this.input.value !== '';
        this.deselectElement.style.visibility = isVisible ? 'visible' : 'hidden';
      }
    };
    Datepicker.prototype.preselectFromInput = function () {
      if (this.input !== null) {
        try {
          var date = this.dateConverter.parseDate(this.options.getInputFormat(), this.input.value);
          if (date !== null) {
            this.options.setInitialDate(date);
          }
        } catch (error) {
          if (!(error instanceof TheDatepicker.CannotParseDateException)) {
            throw error;
          }
        }
      }
    };
    Datepicker.prototype.initListeners = function () {
      var _this = this;
      if (!Datepicker.areGlobalListenersInitialized) {
        var activeViewModel = null;
        var checkMiss = function (event) {
          if (Datepicker.hasClickedViewModel) {
            Datepicker.hasClickedViewModel = false;
          } else {
            Datepicker.activateViewModel(event, null);
          }
        };
        TheDatepicker.Helper.addEventListener(this.document, TheDatepicker.ListenerType.MouseDown, checkMiss);
        TheDatepicker.Helper.addEventListener(this.document, TheDatepicker.ListenerType.FocusIn, checkMiss);
        TheDatepicker.Helper.addEventListener(this.document, TheDatepicker.ListenerType.KeyDown, function (event) {
          var target = event.target || event.srcElement;
          if (target !== null && target === _this.input) {
            return;
          }
          if (Datepicker.activeViewModel !== null) {
            Datepicker.activeViewModel.triggerKeyPress(event, target);
          }
        });
        Datepicker.areGlobalListenersInitialized = true;
      }
      this.removeInitialInputListener();
      var hit = function (event) {
        Datepicker.activateViewModel(event, _this.viewModel);
        Datepicker.hasClickedViewModel = true;
      };
      this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.container, TheDatepicker.ListenerType.MouseDown, hit));
      this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.container, TheDatepicker.ListenerType.FocusIn, hit));
      if (this.deselectElement !== null) {
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.deselectElement, TheDatepicker.ListenerType.MouseDown, hit));
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.deselectElement, TheDatepicker.ListenerType.FocusIn, hit));
      }
      if (this.input !== null) {
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.input, TheDatepicker.ListenerType.MouseDown, hit));
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.input, TheDatepicker.ListenerType.Focus, hit));
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.input, TheDatepicker.ListenerType.Blur, function () {
          _this.updateInput();
        }));
        this.listenerRemovers.push(TheDatepicker.Helper.addEventListener(this.input, TheDatepicker.ListenerType.KeyUp, function (event) {
          _this.readInput(event);
        }));
      }
    };
    Datepicker.prototype.removeInitialInputListener = function () {
      if (this.inputListenerRemover !== null) {
        this.inputListenerRemover();
        this.inputListenerRemover = null;
      }
    };
    Datepicker.activateViewModel = function (event, viewModel) {
      if (Datepicker.activeViewModel === viewModel) {
        return true;
      }
      if (Datepicker.activeViewModel !== null && !Datepicker.activeViewModel.setActive(event, false)) {
        return false;
      }
      if (viewModel === null) {
        Datepicker.activeViewModel = null;
        return true;
      }
      if (!viewModel.setActive(event, true)) {
        return false;
      }
      Datepicker.activeViewModel = viewModel;
      return true;
    };
    Datepicker.areGlobalListenersInitialized = false;
    Datepicker.activeViewModel = null;
    Datepicker.hasClickedViewModel = false;
    return Datepicker;
  }());
  TheDatepicker.Datepicker = Datepicker;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var Day = (function () {
    function Day(date) {
      this.isToday = false;
      this.isPast = false;
      this.isAvailable = true;
      this.isInValidity = true;
      this.isInCurrentMonth = true;
      this.isSelected = false;
      this.isHighlighted = false;
      this.isFocused = false;
      this.dayNumber = date.getDate();
      this.month = date.getMonth() + 1;
      this.year = date.getFullYear();
      this.dayOfWeek = date.getDay();
      this.isWeekend = this.dayOfWeek === TheDatepicker.DayOfWeek.Saturday || this.dayOfWeek === TheDatepicker.DayOfWeek.Sunday;
    }

    Day.prototype.getDate = function () {
      return new Date(this.year, this.month - 1, this.dayNumber, 0, 0, 0, 0);
    };
    Day.prototype.isEqualToDate = function (date) {
      return date !== null && this.dayNumber === date.getDate() && this.month === date.getMonth() + 1 && this.year === date.getFullYear();
    };
    Day.prototype.isEqualToDay = function (day) {
      return day !== null && this.dayNumber === day.dayNumber && this.month === day.month && this.year === day.year;
    };
    return Day;
  }());
  TheDatepicker.Day = Day;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var DayOfWeek;
  (function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
  })(DayOfWeek = TheDatepicker.DayOfWeek || (TheDatepicker.DayOfWeek = {}));
  var Month;
  (function (Month) {
    Month[Month["January"] = 0] = "January";
    Month[Month["February"] = 1] = "February";
    Month[Month["March"] = 2] = "March";
    Month[Month["April"] = 3] = "April";
    Month[Month["May"] = 4] = "May";
    Month[Month["June"] = 5] = "June";
    Month[Month["July"] = 6] = "July";
    Month[Month["August"] = 7] = "August";
    Month[Month["September"] = 8] = "September";
    Month[Month["October"] = 9] = "October";
    Month[Month["November"] = 10] = "November";
    Month[Month["December"] = 11] = "December";
  })(Month = TheDatepicker.Month || (TheDatepicker.Month = {}));
  var KeyCode;
  (function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["Left"] = 37] = "Left";
    KeyCode[KeyCode["Up"] = 38] = "Up";
    KeyCode[KeyCode["Right"] = 39] = "Right";
    KeyCode[KeyCode["Down"] = 40] = "Down";
  })(KeyCode = TheDatepicker.KeyCode || (TheDatepicker.KeyCode = {}));
  var ListenerType;
  (function (ListenerType) {
    ListenerType["MouseDown"] = "mousedown";
    ListenerType["Focus"] = "focus";
    ListenerType["FocusIn"] = "focusin";
    ListenerType["Blur"] = "blur";
    ListenerType["KeyDown"] = "keydown";
    ListenerType["KeyUp"] = "keyup";
  })(ListenerType = TheDatepicker.ListenerType || (TheDatepicker.ListenerType = {}));
  var Helper = (function () {
    function Helper() {
    }

    Helper.resetTime = function (date) {
      if (date === null) {
        return;
      }
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date;
    };
    Helper.normalizeDate = function (parameterName, value) {
      if (value === null) {
        return null;
      }
      if (typeof value === 'string') {
        if (value === 'today' || value === 'now') {
          return Helper.resetTime(new Date());
        }
        var matches = value.match(/^\s*([+-]?)\s*([0-9]+)\s*(day|month|year)s?\s*$/i);
        if (matches !== null) {
          var date_1 = Helper.resetTime(new Date());
          var amount = parseInt(matches[2], 10) * (matches[1] === '-' ? -1 : 1);
          switch (matches[3].toLowerCase()) {
            case 'day':
            case 'days':
              date_1.setDate(date_1.getDate() + amount);
              break;
            case 'month':
            case 'months':
              date_1.setMonth(date_1.getMonth() + amount);
              break;
            case 'year':
            case 'years':
              date_1.setFullYear(date_1.getFullYear() + amount);
              break;
          }
          return date_1;
        }
        var date = new Date(value);
        if (!isNaN(date.getTime())) {
          return Helper.resetTime(date);
        }
      } else if (Helper.isValidDate(value)) {
        return Helper.resetTime(new Date(value.getTime()));
      }
      throw new Error(parameterName + 'was expected to be a valid Date string or valid Date or null.');
    };
    Helper.isElement = function (element) {
      return typeof element === 'object' && element.nodeType === 1 && typeof element.style === 'object' && typeof element.ownerDocument === 'object';
    };
    Helper.isValidDate = function (value) {
      return typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value.getTime());
    };
    Helper.inArray = function (list, item) {
      for (var index = 0; index < list.length; index++) {
        if (list[index] === item) {
          return true;
        }
      }
      return false;
    };
    Helper.addEventListener = function (element, listenerType, listener) {
      if (element.addEventListener) {
        element.addEventListener(listenerType, listener);
        return function () {
          element.removeEventListener(listenerType, listener);
        };
      }
      var listenerProperty = 'on' + listenerType;
      var originalListener = element[listenerProperty] || null;
      element[listenerProperty] = function (event) {
        event = event || window.event;
        if (originalListener !== null) {
          originalListener.call(element, event);
        }
        listener(event);
      };
      return function () {
        element[listenerProperty] = originalListener;
      };
    };
    Helper.preventDefault = function (event) {
      if (event.preventDefault) {
        event.preventDefault();
      } else {
        event.returnValue = false;
      }
    };
    Helper.stopPropagation = function (event) {
      if (event.stopPropagation) {
        event.stopPropagation();
      } else {
        event.cancelBubble = true;
      }
    };
    Helper.checkString = function (parameterName, value, checkNonEmpty) {
      if (checkNonEmpty === void 0) {
        checkNonEmpty = false;
      }
      if (typeof value !== 'string' || (checkNonEmpty && value === '')) {
        throw new Error(parameterName + ' was expected to be a' + (checkNonEmpty ? ' non empty' : '') + ' string.');
      }
    };
    Helper.checkNumber = function (parameterName, value) {
      value = typeof value === 'string' ? parseInt(value) : value;
      if (typeof value !== 'number' || isNaN(value)) {
        throw new Error(parameterName + ' was expected to be a valid number.');
      }
      return value;
    };
    Helper.checkFunction = function (parameterName, value, isNullable) {
      if (isNullable === void 0) {
        isNullable = true;
      }
      if ((!isNullable || value !== null) && typeof value !== 'function') {
        throw new Error(parameterName + ' was expected to be a function' + (isNullable ? ' or null' : '') + '.');
      }
    };
    return Helper;
  }());
  TheDatepicker.Helper = Helper;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var HtmlHelper = (function () {
    function HtmlHelper(options) {
      this.options = options;
      this.document = document;
    }

    HtmlHelper.prototype.createDiv = function (className) {
      var div = this.document.createElement('div');
      this.addClass(div, className);
      return div;
    };
    HtmlHelper.prototype.createAnchor = function (onClick) {
      var anchor = this.document.createElement('a');
      this.addClass(anchor, 'button');
      anchor.href = '#';
      anchor.onclick = function (event) {
        event = event || window.event;
        TheDatepicker.Helper.preventDefault(event);
        onClick(event);
      };
      anchor.onkeydown = function (event) {
        event = event || window.event;
        if (TheDatepicker.Helper.inArray([TheDatepicker.KeyCode.Enter, TheDatepicker.KeyCode.Space], event.keyCode)) {
          TheDatepicker.Helper.preventDefault(event);
          onClick(event);
        }
      };
      return anchor;
    };
    HtmlHelper.prototype.createSpan = function () {
      return this.document.createElement('span');
    };
    HtmlHelper.prototype.createTable = function (className, header, body) {
      var table = this.document.createElement('table');
      this.addClass(table, className);
      table.appendChild(header);
      table.appendChild(body);
      return table;
    };
    HtmlHelper.prototype.createTableHeader = function (className, cells) {
      var tableHeader = this.document.createElement('thead');
      this.addClass(tableHeader, className);
      var row = this.document.createElement('tr');
      for (var index = 0; index < cells.length; index++) {
        row.appendChild(cells[index]);
      }
      tableHeader.appendChild(row);
      return tableHeader;
    };
    HtmlHelper.prototype.createTableHeaderCell = function (className) {
      var cell = this.document.createElement('th');
      this.addClass(cell, className);
      return cell;
    };
    HtmlHelper.prototype.createTableBody = function (className, rows) {
      var tableBody = this.document.createElement('tbody');
      this.addClass(tableBody, className);
      for (var index = 0; index < rows.length; index++) {
        tableBody.appendChild(rows[index]);
      }
      return tableBody;
    };
    HtmlHelper.prototype.createTableRow = function (className, cells) {
      var row = this.document.createElement('tr');
      for (var index = 0; index < cells.length; index++) {
        row.appendChild(cells[index]);
      }
      return row;
    };
    HtmlHelper.prototype.createTableCell = function () {
      return this.document.createElement('td');
    };
    HtmlHelper.prototype.createSelectInput = function (options, onChange) {
      var input = this.document.createElement('select');
      this.addClass(input, 'select');
      for (var index = 0; index < options.length; index++) {
        var option = this.document.createElement('option');
        option.value = options[index].value.toString();
        option.innerText = options[index].label;
        input.appendChild(option);
      }
      input.onchange = function (event) {
        onChange(event || window.event, parseInt(input.value, 10));
      };
      input.onkeydown = function (event) {
        event = event || window.event;
        TheDatepicker.Helper.stopPropagation(event);
      };
      return input;
    };
    HtmlHelper.prototype.addClass = function (element, className) {
      className = this.options.getClassesPrefix() + className;
      if (element.className !== '') {
        className = ' ' + className;
      }
      element.className += className;
    };
    return HtmlHelper;
  }());
  TheDatepicker.HtmlHelper = HtmlHelper;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var MoveDirection;
  (function (MoveDirection) {
    MoveDirection[MoveDirection["Left"] = -1] = "Left";
    MoveDirection[MoveDirection["Up"] = -7] = "Up";
    MoveDirection[MoveDirection["Right"] = 1] = "Right";
    MoveDirection[MoveDirection["Down"] = 7] = "Down";
  })(MoveDirection = TheDatepicker.MoveDirection || (TheDatepicker.MoveDirection = {}));
  var ViewModel = (function () {
    function ViewModel(options, datepicker) {
      this.options = options;
      this.datepicker = datepicker;
      this.selectedDate = null;
      this.currentMonth = null;
      this.highlightedDay = null;
      this.isHighlightedDayFocused = false;
      this.active = false;
      this.today = TheDatepicker.Helper.resetTime(new Date());
    }

    ViewModel.prototype.render = function () {
      if (this.selectedDate !== null) {
        if ((!this.options.isDateInValidity(this.selectedDate) || !this.options.isDateAvailable(this.selectedDate)) && this.cancelSelection(null)) {
          return;
        }
      } else if (!this.options.isAllowedEmpty() && this.selectDay(null, this.options.getInitialDate(), false)) {
        return;
      }
      var correctMonth = this.options.correctMonth(this.getCurrentMonth());
      if (this.goToMonth(null, correctMonth)) {
        return;
      }
      this.options.template.render(this, this.datepicker);
      this.datepicker.updateInput();
    };
    ViewModel.prototype.setActive = function (event, value) {
      if (this.active === value) {
        return true;
      }
      if (!this.triggerOnBeforeSwitch(event, value)) {
        return false;
      }
      this.active = value;
      if (this.options.isHiddenOnBlur()) {
        this.render();
      }
      this.triggerOnSwitch(event, value);
      return true;
    };
    ViewModel.prototype.isActive = function () {
      return this.active;
    };
    ViewModel.prototype.getCurrentMonth = function () {
      if (this.currentMonth === null) {
        this.currentMonth = this.options.getInitialMonth();
      }
      return this.currentMonth;
    };
    ViewModel.prototype.canGoBack = function () {
      var newMonth = new Date(this.getCurrentMonth().getTime());
      newMonth.setMonth(newMonth.getMonth() - 1);
      return this.canGoToMonth(newMonth);
    };
    ViewModel.prototype.canGoForward = function () {
      var newMonth = new Date(this.getCurrentMonth().getTime());
      newMonth.setMonth(newMonth.getMonth() + 1);
      return this.canGoToMonth(newMonth);
    };
    ViewModel.prototype.canGoToMonth = function (month) {
      return this.options.isMonthInValidity(month);
    };
    ViewModel.prototype.goBack = function (event) {
      var newMonth = new Date(this.getCurrentMonth().getTime());
      newMonth.setMonth(newMonth.getMonth() - 1);
      return this.goToMonth(event, newMonth);
    };
    ViewModel.prototype.goForward = function (event) {
      var newMonth = new Date(this.getCurrentMonth().getTime());
      newMonth.setMonth(newMonth.getMonth() + 1);
      return this.goToMonth(event, newMonth);
    };
    ViewModel.prototype.goToMonth = function (event, month, doCancelHighlight) {
      if (doCancelHighlight === void 0) {
        doCancelHighlight = true;
      }
      month = TheDatepicker.Helper.resetTime(new Date(month.getTime()));
      month.setDate(1);
      if (month.getTime() === this.getCurrentMonth().getTime() || !this.canGoToMonth(month)) {
        return false;
      }
      if (!this.triggerOnBeforeGo(event, month, this.currentMonth)) {
        return false;
      }
      this.currentMonth = month;
      if (!doCancelHighlight || !this.cancelHighlight()) {
        this.render();
      }
      this.triggerOnGo(event, month, this.currentMonth);
      return true;
    };
    ViewModel.prototype.reset = function (event) {
      var isMonthChanged = this.goToMonth(event, this.options.getInitialMonth());
      var isDaySelected = this.selectDay(event, this.options.getInitialDate(), false);
      return isMonthChanged || isDaySelected;
    };
    ViewModel.prototype.selectDay = function (event, date, doUpdateMonth, doHighlight, canToggle) {
      if (doUpdateMonth === void 0) {
        doUpdateMonth = true;
      }
      if (doHighlight === void 0) {
        doHighlight = false;
      }
      if (canToggle === void 0) {
        canToggle = false;
      }
      if (date === null) {
        return this.cancelSelection(event);
      }
      var day;
      if (date instanceof TheDatepicker.Day) {
        day = date;
        date = day.getDate();
      } else {
        day = this.createDay(date);
      }
      if (!day.isAvailable) {
        return false;
      }
      if (day.isEqualToDate(this.selectedDate)) {
        if (canToggle && this.options.hasToggleSelection()) {
          return this.cancelSelection(event);
        }
        return false;
      }
      var previousDay = this.selectedDate !== null ? this.createDay(this.selectedDate) : null;
      if (!this.triggerOnBeforeSelect(event, day, previousDay)) {
        return false;
      }
      this.selectedDate = day.getDate();
      if (doHighlight) {
        this.highlightedDay = day;
        this.isHighlightedDayFocused = true;
      }
      if (!doUpdateMonth || !this.goToMonth(event, date)) {
        this.render();
      }
      this.triggerOnSelect(event, day, previousDay);
      return true;
    };
    ViewModel.prototype.selectDateSince = function (event, date) {
      var maxDate = this.options.getMaxDate();
      var maxLoops = 100;
      var day = this.createDay(date);
      date = day.getDate();
      while (!day.isAvailable && maxLoops > 0) {
        date.setDate(day.dayNumber + 1);
        if (maxDate !== null && date.getTime() > maxDate.getTime()) {
          break;
        }
        day = this.createDay(date);
        maxLoops--;
      }
      return this.selectDay(event, date);
    };
    ViewModel.prototype.highlightDay = function (event, day, doUpdateMonth) {
      if (doUpdateMonth === void 0) {
        doUpdateMonth = false;
      }
      if (!day.isAvailable) {
        return false;
      }
      if (day.isEqualToDay(this.highlightedDay)) {
        return false;
      }
      this.highlightedDay = day;
      this.isHighlightedDayFocused = true;
      var date = day.getDate();
      if (!doUpdateMonth || !this.goToMonth(event, date, false)) {
        this.render();
      }
      return true;
    };
    ViewModel.prototype.highlightFirstAvailableDay = function (event) {
      var date = new Date(this.getCurrentMonth().getTime());
      var maxDate = this.options.getMaxDate();
      var day = this.createDay(date);
      while (!day.isAvailable) {
        date.setDate(day.dayNumber + 1);
        if (date.getDate() === 1) {
          break;
        }
        if (maxDate !== null && date.getTime() > maxDate.getTime()) {
          break;
        }
        day = this.createDay(date);
      }
      return this.highlightDay(event, day);
    };
    ViewModel.prototype.highlightSiblingDay = function (event, day, direction) {
      var newDay = day;
      var date = newDay.getDate();
      var maxLoops = 100;
      do {
        date.setDate(newDay.dayNumber + direction);
        newDay = this.createDay(date);
        if (!newDay.isInValidity) {
          break;
        }
        maxLoops--;
      } while (!newDay.isAvailable && maxLoops > 0);
      return this.highlightDay(event, newDay, true);
    };
    ViewModel.prototype.cancelSelection = function (event) {
      if (!this.options.isAllowedEmpty()) {
        return false;
      }
      if (this.selectedDate === null) {
        return false;
      }
      var previousDay = this.createDay(this.selectedDate);
      if (!this.triggerOnBeforeSelect(event, null, previousDay)) {
        return false;
      }
      this.selectedDate = null;
      this.render();
      this.triggerOnSelect(event, null, previousDay);
      return true;
    };
    ViewModel.prototype.cancelHighlight = function () {
      if (this.highlightedDay === null) {
        return false;
      }
      this.highlightedDay = null;
      this.render();
      return true;
    };
    ViewModel.prototype.getWeekDays = function () {
      var weekDays = [];
      for (var day = 0; day < 7; day++) {
        weekDays.push((this.options.getFirstDayOfWeek() + day) % 7);
      }
      return weekDays;
    };
    ViewModel.prototype.getWeeks = function () {
      var date;
      var days = [];
      var currentMonth = this.getCurrentMonth();
      var firstDateOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
      var lastMonthDaysCount = (new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0)).getDate();
      var prependDaysCount = (firstDateOfMonth.getDay() - this.options.getFirstDayOfWeek() + 7) % 7;
      for (date = lastMonthDaysCount - prependDaysCount + 1; date <= lastMonthDaysCount; date++) {
        var day = this.createDay(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, date));
        day.isInCurrentMonth = false;
        days.push(day);
      }
      var lastDateOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
      var monthDaysCount = lastDateOfMonth.getDate();
      for (date = 1; date <= monthDaysCount; date++) {
        days.push(this.createDay(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), date)));
      }
      var appendDaysCount = 6 - ((lastDateOfMonth.getDay() - this.options.getFirstDayOfWeek() + 7) % 7);
      for (date = 1; date <= appendDaysCount; date++) {
        var day = this.createDay(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, date));
        day.isInCurrentMonth = false;
        days.push(day);
      }
      if (this.options.hasFixedRowsCount()) {
        for (var date_2 = appendDaysCount + 1; days.length < 6 * 7; date_2++) {
          var day = this.createDay(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, date_2));
          day.isInCurrentMonth = false;
          days.push(day);
        }
      }
      var weeks = [];
      for (var i = 0; i < days.length; i += 7) {
        weeks.push(days.slice(i, i + 7));
      }
      return weeks;
    };
    ViewModel.prototype.triggerKeyPress = function (event, target) {
      if (TheDatepicker.Helper.inArray([TheDatepicker.KeyCode.Left, TheDatepicker.KeyCode.Up, TheDatepicker.KeyCode.Right, TheDatepicker.KeyCode.Down], event.keyCode)) {
        TheDatepicker.Helper.preventDefault(event);
        if (this.highlightedDay !== null) {
          this.highlightSiblingDay(event, this.highlightedDay, this.translateKeyCodeToMoveDirection(event.keyCode));
        } else if (this.selectedDate !== null && this.selectedDate.getFullYear() === this.getCurrentMonth().getFullYear() && this.selectedDate.getMonth() === this.getCurrentMonth().getMonth()) {
          this.highlightSiblingDay(event, this.createDay(this.selectedDate), this.translateKeyCodeToMoveDirection(event.keyCode));
        } else {
          this.highlightFirstAvailableDay(event);
        }
      }
    };
    ViewModel.prototype.triggerOnBeforeSelect = function (event, day, previousDay) {
      return this.options.triggerEvent(TheDatepicker.EventType.BeforeSelect, function (listener) {
        return listener.call(day, event, day, previousDay);
      });
    };
    ViewModel.prototype.triggerOnSelect = function (event, day, previousDay) {
      this.options.triggerEvent(TheDatepicker.EventType.Select, function (listener) {
        return listener.call(day, event, day, previousDay);
      });
    };
    ViewModel.prototype.triggerOnBeforeSwitch = function (event, isOpening) {
      var _this = this;
      return this.options.triggerEvent(TheDatepicker.EventType.BeforeSwitch, function (listener) {
        return listener.call(_this.datepicker, event, isOpening);
      });
    };
    ViewModel.prototype.triggerOnSwitch = function (event, isOpening) {
      var _this = this;
      this.options.triggerEvent(TheDatepicker.EventType.Switch, function (listener) {
        return listener.call(_this.datepicker, event, isOpening);
      });
    };
    ViewModel.prototype.triggerOnBeforeGo = function (event, month, previousMonth) {
      return this.options.triggerEvent(TheDatepicker.EventType.BeforeGo, function (listener) {
        return listener.call(month, event, month, previousMonth);
      });
    };
    ViewModel.prototype.triggerOnGo = function (event, month, previousMonth) {
      this.options.triggerEvent(TheDatepicker.EventType.Go, function (listener) {
        return listener.call(month, event, month, previousMonth);
      });
    };
    ViewModel.prototype.createDay = function (date) {
      date = TheDatepicker.Helper.resetTime(new Date(date.getTime()));
      var day = new TheDatepicker.Day(date);
      day.isToday = date.getTime() === this.today.getTime();
      day.isPast = date.getTime() < this.today.getTime();
      day.isInValidity = this.options.isDateInValidity(date);
      day.isAvailable = day.isInValidity && this.options.isDateAvailable(date);
      if (day.isAvailable) {
        if (day.isEqualToDate(this.selectedDate)) {
          day.isSelected = true;
        }
        if (day.isEqualToDay(this.highlightedDay)) {
          day.isHighlighted = true;
          if (this.isHighlightedDayFocused) {
            day.isFocused = true;
          }
        }
      }
      return day;
    };
    ViewModel.prototype.translateKeyCodeToMoveDirection = function (key) {
      switch (key) {
        case TheDatepicker.KeyCode.Left:
          return MoveDirection.Left;
        case TheDatepicker.KeyCode.Up:
          return MoveDirection.Up;
        case TheDatepicker.KeyCode.Right:
          return MoveDirection.Right;
        case TheDatepicker.KeyCode.Down:
          return MoveDirection.Down;
        default:
          throw new Error('Invalid key code: ' + key);
      }
    };
    return ViewModel;
  }());
  TheDatepicker.ViewModel = ViewModel;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var Template = (function () {
    function Template(options, htmlHelper) {
      this.containerElement = null;
      this.goBackElement = null;
      this.goForwardElement = null;
      this.titleElement = null;
      this.resetElement = null;
      this.closeElement = null;
      this.monthSelect = null;
      this.monthElement = null;
      this.yearSelect = null;
      this.yearElement = null;
      this.weeksElements = [];
      this.daysElements = [];
      this.daysContentsElements = [];
      this.options = options;
      this.htmlHelper = htmlHelper;
    }

    Template.prototype.render = function (viewModel, datepicker) {
      if (this.containerElement === null) {
        if (datepicker.input !== null && this.options.isHiddenOnBlur() && !viewModel.isActive()) {
          return;
        }
        datepicker.container.innerHTML = '';
        datepicker.container.appendChild(this.createSkeleton(viewModel, datepicker));
      }
      this.updateContainerElement(viewModel, datepicker.input);
      this.updateTitleElement(viewModel);
      this.updateCloseElement(viewModel, datepicker.input);
      this.updateResetElement(viewModel);
      this.updateGoBackElement(viewModel);
      this.updateGoForwardElement(viewModel);
      this.updateMonthElement(viewModel);
      this.updateYearElement(viewModel);
      this.updateWeeksElements(viewModel);
    };
    Template.prototype.createSkeleton = function (viewModel, datepicker) {
      var container = this.htmlHelper.createDiv('container');
      container.appendChild(this.createHeaderElement(viewModel, datepicker));
      container.appendChild(this.createBodyElement(viewModel, datepicker));
      this.containerElement = container;
      return container;
    };
    Template.prototype.updateContainerElement = function (viewModel, input) {
      this.containerElement.style.display = input === null || viewModel.isActive() || !this.options.isHiddenOnBlur() ? 'block' : 'none';
    };
    Template.prototype.createHeaderElement = function (viewModel, datepicker) {
      var state = this.htmlHelper.createDiv('state');
      state.appendChild(this.createMonthElement(viewModel));
      state.appendChild(this.createYearElement(viewModel));
      var navigation = this.htmlHelper.createDiv('navigation');
      navigation.appendChild(this.createGoBackElement(viewModel));
      navigation.appendChild(state);
      navigation.appendChild(this.createGoForwardElement(viewModel));
      var control = this.htmlHelper.createDiv('control');
      control.appendChild(this.createTitleElement(viewModel));
      control.appendChild(this.createCloseElement(viewModel, datepicker));
      control.appendChild(this.createResetElement(viewModel));
      var header = this.htmlHelper.createDiv('header');
      header.appendChild(control);
      header.appendChild(navigation);
      return header;
    };
    Template.prototype.createTitleElement = function (viewModel) {
      var titleElement = this.htmlHelper.createDiv('title');
      this.titleElement = titleElement;
      return titleElement;
    };
    Template.prototype.updateTitleElement = function (viewModel) {
      var title = this.options.getTitle();
      this.titleElement.style.display = title !== '' ? 'block' : 'none';
      this.titleElement.innerText = title;
    };
    Template.prototype.createResetElement = function (viewModel) {
      var resetElement = this.htmlHelper.createDiv('reset');
      var resetButton = this.htmlHelper.createAnchor(function (event) {
        viewModel.reset(event);
      });
      resetButton.innerHTML = this.options.getResetHtml();
      resetElement.appendChild(resetButton);
      this.resetElement = resetElement;
      return resetElement;
    };
    Template.prototype.updateResetElement = function (viewModel) {
      this.resetElement.style.display = this.options.isResetButtonShown() ? 'block' : 'none';
    };
    Template.prototype.createCloseElement = function (viewModel, datepicker) {
      var closeElement = this.htmlHelper.createDiv('close');
      var closeButton = this.htmlHelper.createAnchor(function (event) {
        datepicker.close(event);
      });
      closeButton.innerHTML = this.options.getCloseHtml();
      closeElement.appendChild(closeButton);
      this.closeElement = closeElement;
      return closeElement;
    };
    Template.prototype.updateCloseElement = function (viewModel, input) {
      this.closeElement.style.display = input !== null && this.options.isHiddenOnBlur() && this.options.isCloseButtonShown() ? 'block' : 'none';
    };
    Template.prototype.createGoBackElement = function (viewModel) {
      return this.createGoElement(viewModel, false);
    };
    Template.prototype.createGoForwardElement = function (viewModel) {
      return this.createGoElement(viewModel, true);
    };
    Template.prototype.createGoElement = function (viewModel, directionForward) {
      var goElement = this.htmlHelper.createDiv('go');
      this.htmlHelper.addClass(goElement, directionForward ? 'go-next' : 'go-previous');
      var goButton = this.htmlHelper.createAnchor(function (event) {
        if (directionForward) {
          viewModel.goForward(event);
        } else {
          viewModel.goBack(event);
        }
      });
      goButton.innerHTML = directionForward ? this.options.getGoForwardHtml() : this.options.getGoBackHtml();
      goElement.appendChild(goButton);
      if (directionForward) {
        this.goForwardElement = goButton;
      } else {
        this.goBackElement = goButton;
      }
      return goElement;
    };
    Template.prototype.updateGoBackElement = function (viewModel) {
      this.goBackElement.style.visibility = viewModel.canGoBack() ? 'visible' : 'hidden';
    };
    Template.prototype.updateGoForwardElement = function (viewModel) {
      this.goForwardElement.style.visibility = viewModel.canGoForward() ? 'visible' : 'hidden';
    };
    Template.prototype.createMonthElement = function (viewModel) {
      var options = [];
      for (var monthNumber = 0; monthNumber < 12; monthNumber++) {
        options.push({value: monthNumber, label: this.options.translator.translateMonth(monthNumber)});
      }
      var selectElement = this.htmlHelper.createSelectInput(options, function (event, monthNumber) {
        var newMonth = new Date(viewModel.getCurrentMonth().getTime());
        newMonth.setMonth(monthNumber);
        viewModel.goToMonth(event, newMonth);
      });
      var monthElement = this.htmlHelper.createDiv('month');
      var monthSpan = this.htmlHelper.createSpan();
      monthElement.appendChild(selectElement);
      monthElement.appendChild(monthSpan);
      this.monthElement = monthSpan;
      this.monthSelect = selectElement;
      return monthElement;
    };
    Template.prototype.updateMonthElement = function (viewModel) {
      var currentMonth = viewModel.getCurrentMonth().getMonth();
      this.monthElement.innerText = this.options.translator.translateMonth(currentMonth);
      if (!this.options.isMonthAsDropdown()) {
        this.monthSelect.style.display = 'none';
        this.monthElement.style.display = 'inline';
        return;
      }
      var valuesCount = 0;
      for (var monthNumber = 0; monthNumber < 12; monthNumber++) {
        var newMonth = new Date(viewModel.getCurrentMonth().getTime());
        newMonth.setMonth(monthNumber);
        var option = this.monthSelect.getElementsByTagName('option')[monthNumber];
        var canGoToMonth = viewModel.canGoToMonth(newMonth);
        option.disabled = !canGoToMonth;
        option.style.display = canGoToMonth ? 'block' : 'none';
        valuesCount += canGoToMonth ? 1 : 0;
      }
      this.monthSelect.value = currentMonth.toString();
      this.monthSelect.style.display = valuesCount > 1 ? 'inline-block' : 'none';
      this.monthElement.style.display = valuesCount > 1 ? 'none' : 'inline';
    };
    Template.prototype.createYearElement = function (viewModel) {
      var options = [];
      var limits = this.options.getYearsSelectionLimits();
      for (var year = limits.from; year <= limits.to; year++) {
        options.push({value: year, label: year.toString()});
      }
      var selectElement = this.htmlHelper.createSelectInput(options, function (event, year) {
        var newYear = new Date(viewModel.getCurrentMonth().getTime());
        newYear.setFullYear(year);
        viewModel.goToMonth(event, newYear);
      });
      var yearElement = this.htmlHelper.createDiv('year');
      var yearSpan = this.htmlHelper.createSpan();
      yearElement.appendChild(selectElement);
      yearElement.appendChild(yearSpan);
      this.yearElement = yearSpan;
      this.yearSelect = selectElement;
      return yearElement;
    };
    Template.prototype.updateYearElement = function (viewModel) {
      var currentYear = viewModel.getCurrentMonth().getFullYear();
      this.yearElement.innerText = currentYear.toString();
      if (!this.options.isYearAsDropdown()) {
        this.yearSelect.style.display = 'none';
        this.yearElement.style.display = 'inline';
        return;
      }
      var options = this.yearSelect.getElementsByTagName('option');
      var yearFrom = parseInt(options[0].value, 10);
      var minDate = this.options.getMinDate();
      var minYear = minDate !== null ? minDate.getFullYear() : null;
      var maxDate = this.options.getMaxDate();
      var maxYear = maxDate !== null ? maxDate.getFullYear() : null;
      var valuesCount = 0;
      var includesCurrentYear = false;
      for (var index = 0; index < options.length; index++) {
        var year = yearFrom + index;
        if (year === currentYear) {
          includesCurrentYear = true;
        }
        var canGoToYear = void 0;
        if (year === minYear || year === maxYear) {
          var newYear = new Date(viewModel.getCurrentMonth().getTime());
          newYear.setFullYear(year);
          canGoToYear = viewModel.canGoToMonth(newYear);
        } else {
          canGoToYear = (minYear === null || year > minYear) && (maxYear === null || year < maxYear);
        }
        options[index].disabled = !canGoToYear;
        options[index].style.display = canGoToYear ? 'block' : 'none';
        valuesCount += canGoToYear ? 1 : 0;
      }
      if (includesCurrentYear) {
        this.yearSelect.value = currentYear.toString();
      }
      var isSelectVisible = includesCurrentYear && valuesCount > 1;
      this.yearSelect.style.display = isSelectVisible ? 'inline-block' : 'none';
      this.yearElement.style.display = isSelectVisible ? 'none' : 'inline';
    };
    Template.prototype.createTableElement = function (viewModel, datepicker) {
      var tableHeader = this.createTableHeaderElement(viewModel);
      var tableBody = this.createTableBodyElement(viewModel, datepicker);
      return this.htmlHelper.createTable('table', tableHeader, tableBody);
    };
    Template.prototype.createTableHeaderElement = function (viewModel) {
      var weekDays = viewModel.getWeekDays();
      var cells = [];
      for (var index = 0; index < weekDays.length; index++) {
        var dayOfWeek = weekDays[index];
        cells.push(this.createTableHeaderCellElement(viewModel, dayOfWeek));
      }
      return this.htmlHelper.createTableHeader('table-header', cells);
    };
    Template.prototype.createTableHeaderCellElement = function (viewModel, dayOfWeek) {
      var headerCell = this.htmlHelper.createTableHeaderCell('table-header-cell');
      if (dayOfWeek === TheDatepicker.DayOfWeek.Saturday || dayOfWeek === TheDatepicker.DayOfWeek.Sunday) {
        this.htmlHelper.addClass(headerCell, 'weekend');
      }
      headerCell.innerText = this.options.translator.translateDayOfWeek(dayOfWeek);
      return headerCell;
    };
    Template.prototype.createTableBodyElement = function (viewModel, datepicker) {
      this.daysElements = [];
      this.daysContentsElements = [];
      var rows = [];
      for (var index = 0; index < 6; index++) {
        rows.push(this.createTableRowElement(viewModel, datepicker));
      }
      this.weeksElements = rows;
      return this.htmlHelper.createTableBody('table-body', rows);
    };
    Template.prototype.updateWeeksElements = function (viewModel) {
      var weeks = viewModel.getWeeks();
      for (var weekIndex = 0; weekIndex < this.weeksElements.length; weekIndex++) {
        var weekElement = this.weeksElements[weekIndex];
        var week = weeks.length > weekIndex ? weeks[weekIndex] : null;
        weekElement.style.display = week !== null ? 'table-row' : 'none';
        if (week !== null) {
          for (var dayIndex = 0; dayIndex < this.daysElements[weekIndex].length; dayIndex++) {
            this.updateDayElement(viewModel, this.daysElements[weekIndex][dayIndex], this.daysContentsElements[weekIndex][dayIndex], week[dayIndex]);
          }
        }
      }
    };
    Template.prototype.createTableRowElement = function (viewModel, datepicker) {
      var cells = [];
      var cellsContents = [];
      for (var index = 0; index < 7; index++) {
        var cell = this.htmlHelper.createTableCell();
        var cellContent = this.createTableCellContentElement(viewModel, datepicker);
        cells.push(cell);
        cellsContents.push(cellContent);
        cell.appendChild(cellContent);
      }
      this.daysElements.push(cells);
      this.daysContentsElements.push(cellsContents);
      return this.htmlHelper.createTableRow('week', cells);
    };
    Template.prototype.updateDayElement = function (viewModel, dayElement, dayContentElement, day) {
      dayContentElement.day = day;
      dayElement.className = '';
      if (!day.isInCurrentMonth && !this.options.areDaysOutOfMonthVisible()) {
        dayContentElement.innerText = '';
        dayContentElement.removeAttribute('href');
        dayContentElement.style.visibility = 'hidden';
        return;
      }
      this.htmlHelper.addClass(dayElement, 'day');
      if (day.isToday) {
        this.htmlHelper.addClass(dayElement, 'today');
      }
      if (day.isWeekend) {
        this.htmlHelper.addClass(dayElement, 'weekend');
      }
      if (!day.isAvailable) {
        this.htmlHelper.addClass(dayElement, 'unavailable');
      }
      if (!day.isInCurrentMonth) {
        this.htmlHelper.addClass(dayElement, 'outside');
      }
      if (day.isHighlighted) {
        this.htmlHelper.addClass(dayElement, 'highlighted');
      }
      if (day.isSelected) {
        this.htmlHelper.addClass(dayElement, 'selected');
      }
      var customClasses = this.options.getCellClasses(day);
      for (var index = 0; index < customClasses.length; index++) {
        dayElement.className += ' ' + customClasses[index];
      }
      dayContentElement.style.visibility = 'visible';
      dayContentElement.innerText = this.options.getCellContent(day);
      if (day.isAvailable) {
        dayContentElement.href = '#';
      } else {
        dayContentElement.removeAttribute('href');
      }
      if (day.isFocused) {
        dayContentElement.focus();
      }
    };
    Template.prototype.createTableCellContentElement = function (viewModel, datepicker) {
      var _this = this;
      var cellContent = this.htmlHelper.createAnchor(function (event) {
        viewModel.selectDay(event, cellContent.day, false, true, true);
        if (_this.options.isHiddenOnSelect()) {
          datepicker.close(event);
        }
      });
      cellContent.onfocus = function (event) {
        viewModel.highlightDay(event || window.event, cellContent.day);
      };
      cellContent.onmouseenter = function () {
        viewModel.cancelHighlight();
      };
      cellContent.onmouseleave = function () {
        viewModel.cancelHighlight();
      };
      return cellContent;
    };
    Template.prototype.createBodyElement = function (viewModel, datepicker) {
      var body = this.htmlHelper.createDiv('body');
      body.appendChild(this.createTableElement(viewModel, datepicker));
      return body;
    };
    return Template;
  }());
  TheDatepicker.Template = Template;
})(TheDatepicker || (TheDatepicker = {}));
var TheDatepicker;
(function (TheDatepicker) {
  var EventType;
  (function (EventType) {
    EventType["BeforeSelect"] = "beforeSelect";
    EventType["Select"] = "select";
    EventType["BeforeSwitch"] = "beforeSwitch";
    EventType["Switch"] = "switch";
    EventType["Go"] = "go";
    EventType["BeforeGo"] = "beforeGo";
  })(EventType = TheDatepicker.EventType || (TheDatepicker.EventType = {}));
  var Options = (function () {
    function Options() {
      this.hideOnBlur = true;
      this.hideOnSelect = true;
      this.minDate = null;
      this.maxDate = null;
      this.initialDate = null;
      this.initialMonth = null;
      this.firstDayOfWeek = TheDatepicker.DayOfWeek.Monday;
      this.dateAvailabilityResolver = null;
      this.cellContentResolver = null;
      this.cellClassesResolver = null;
      this.inputFormat = 'j. n. Y';
      this.daysOutOfMonthVisible = false;
      this.fixedRowsCount = false;
      this.toggleSelection = false;
      this.allowEmpty = true;
      this.showDeselectButton = true;
      this.showResetButton = false;
      this.monthAsDropdown = true;
      this.yearAsDropdown = true;
      this.classesPrefix = 'the-datepicker-';
      this.showCloseButton = true;
      this.title = '';
      this.yearsSelectionLimits = {from: 1900, to: 2100};
      this.goBackHtml = '&lt;';
      this.goForwardHtml = '&gt;';
      this.closeHtml = '&times;';
      this.resetHtml = '&olarr;';
      this.deselectHtml = '&times;';
      this.listeners = {beforeSelect: [], select: [], beforeSwitch: [], "switch": [], go: [], beforeGo: []};
      this.translator = new TheDatepicker.Translator();
      this.template = new TheDatepicker.Template(this, new TheDatepicker.HtmlHelper(this));
    }

    Options.prototype.setHideOnBlur = function (value) {
      this.hideOnBlur = !!value;
    };
    Options.prototype.setHideOnSelect = function (value) {
      this.hideOnSelect = !!value;
    };
    Options.prototype.setMinDate = function (date) {
      var normalizedDate = TheDatepicker.Helper.normalizeDate('Min date', date);
      this.checkConstraints(normalizedDate, this.maxDate);
      this.minDate = normalizedDate;
    };
    Options.prototype.setMaxDate = function (date) {
      var normalizedDate = TheDatepicker.Helper.normalizeDate('Max date', date);
      this.checkConstraints(this.minDate, normalizedDate);
      this.maxDate = normalizedDate;
    };
    Options.prototype.setInitialMonth = function (month) {
      this.initialMonth = TheDatepicker.Helper.normalizeDate('Initial month', month);
    };
    Options.prototype.setInitialDate = function (value) {
      this.initialDate = TheDatepicker.Helper.normalizeDate('Initial date', value);
    };
    Options.prototype.setFirstDayOfWeek = function (dayOfWeek) {
      dayOfWeek = TheDatepicker.Helper.checkNumber('First day of week', dayOfWeek);
      if (dayOfWeek < 0 || dayOfWeek > 6) {
        throw new Error('First day of week was expected to be a number from 0 to 6.');
      }
      this.firstDayOfWeek = dayOfWeek;
    };
    Options.prototype.setDateAvailabilityResolver = function (resolver) {
      TheDatepicker.Helper.checkFunction('Date availability resolver', resolver);
      this.dateAvailabilityResolver = resolver;
    };
    Options.prototype.setCellContentResolver = function (resolver) {
      TheDatepicker.Helper.checkFunction('Cell content resolver', resolver);
      this.cellContentResolver = resolver;
    };
    Options.prototype.setCellClassesResolver = function (resolver) {
      TheDatepicker.Helper.checkFunction('Cell classes resolver', resolver);
      this.cellClassesResolver = resolver;
    };
    Options.prototype.setInputFormat = function (format) {
      TheDatepicker.Helper.checkString('Input format', format, true);
      this.inputFormat = format;
    };
    Options.prototype.setDaysOutOfMonthVisible = function (value) {
      this.daysOutOfMonthVisible = !!value;
    };
    Options.prototype.setFixedRowsCount = function (value) {
      this.fixedRowsCount = !!value;
    };
    Options.prototype.setToggleSelection = function (value) {
      this.toggleSelection = !!value;
    };
    Options.prototype.setShowDeselectButton = function (value) {
      this.showDeselectButton = !!value;
    };
    Options.prototype.setAllowEmpty = function (value) {
      this.allowEmpty = !!value;
    };
    Options.prototype.setShowResetButton = function (value) {
      this.showResetButton = !!value;
    };
    Options.prototype.setMonthAsDropdown = function (value) {
      this.monthAsDropdown = !!value;
    };
    Options.prototype.setYearAsDropdown = function (value) {
      this.yearAsDropdown = !!value;
    };
    Options.prototype.setClassesPrefix = function (prefix) {
      TheDatepicker.Helper.checkString('Prefix', prefix);
      this.classesPrefix = prefix;
    };
    Options.prototype.setShowCloseButton = function (value) {
      this.showCloseButton = !!value;
    };
    Options.prototype.setTitle = function (title) {
      title = title === null ? '' : title;
      TheDatepicker.Helper.checkString('Title', title);
      this.title = title;
    };
    Options.prototype.setYearsSelectionLimits = function (from, to) {
      var parameterName = 'Years selection limits';
      from = TheDatepicker.Helper.checkNumber(parameterName, from);
      to = TheDatepicker.Helper.checkNumber(parameterName, to);
      if (from > to) {
        throw new Error(parameterName + ' - from cannot be higher than to.');
      }
      this.yearsSelectionLimits = {from: from, to: to};
    };
    Options.prototype.setGoBackHtml = function (html) {
      TheDatepicker.Helper.checkString('Html', html);
      this.goBackHtml = html;
    };
    Options.prototype.setGoForwardHtml = function (html) {
      TheDatepicker.Helper.checkString('Html', html);
      this.goForwardHtml = html;
    };
    Options.prototype.setCloseHtml = function (html) {
      TheDatepicker.Helper.checkString('Html', html);
      this.closeHtml = html;
    };
    Options.prototype.setResetHtml = function (html) {
      TheDatepicker.Helper.checkString('Html', html);
      this.resetHtml = html;
    };
    Options.prototype.setDeselectHtml = function (html) {
      TheDatepicker.Helper.checkString('Html', html);
      this.deselectHtml = html;
    };
    Options.prototype.onBeforeSelect = function (listener) {
      this.onEventListener(EventType.BeforeSelect, listener);
    };
    Options.prototype.offBeforeSelect = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.BeforeSelect, listener);
    };
    Options.prototype.onSelect = function (listener) {
      this.onEventListener(EventType.Select, listener);
    };
    Options.prototype.offSelect = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.Select, listener);
    };
    Options.prototype.onBeforeSwitch = function (listener) {
      this.onEventListener(EventType.BeforeSwitch, listener);
    };
    Options.prototype.offBeforeSwitch = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.BeforeSwitch, listener);
    };
    Options.prototype.onSwitch = function (listener) {
      this.onEventListener(EventType.Switch, listener);
    };
    Options.prototype.offSwitch = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.Switch, listener);
    };
    Options.prototype.onBeforeGo = function (listener) {
      this.onEventListener(EventType.BeforeGo, listener);
    };
    Options.prototype.offBeforeGo = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.BeforeGo, listener);
    };
    Options.prototype.onGo = function (listener) {
      this.onEventListener(EventType.Go, listener);
    };
    Options.prototype.offGo = function (listener) {
      if (listener === void 0) {
        listener = null;
      }
      this.offEventListener(EventType.Go, listener);
    };
    Options.prototype.getInitialMonth = function () {
      var initialMonth = this.initialMonth !== null ? new Date(this.initialMonth.getTime()) : (this.initialDate !== null ? new Date(this.initialDate.getTime()) : TheDatepicker.Helper.resetTime(new Date()));
      initialMonth.setDate(1);
      return this.correctMonth(initialMonth);
    };
    Options.prototype.isMonthInValidity = function (month) {
      return this.calculateMonthCorrection(month) === null;
    };
    Options.prototype.correctMonth = function (month) {
      var correctMonth = this.calculateMonthCorrection(month);
      return correctMonth !== null ? correctMonth : month;
    };
    Options.prototype.getInitialDate = function () {
      if (this.isAllowedEmpty()) {
        return this.initialDate !== null && this.isDateInValidity(this.initialDate) && this.isDateAvailable(this.initialDate) ? this.initialDate : null;
      }
      var initialDate = this.initialDate !== null ? new Date(this.initialDate.getTime()) : TheDatepicker.Helper.resetTime(new Date());
      initialDate = this.correctDate(initialDate);
      if (this.isDateAvailable(initialDate)) {
        return initialDate;
      }
      var maxLoops = 150;
      var increasedDate = initialDate;
      var decreasedDate = new Date(initialDate.getTime());
      do {
        if (increasedDate !== null) {
          increasedDate.setDate(increasedDate.getDate() + 1);
          if (this.maxDate !== null && increasedDate.getTime() > this.maxDate.getTime()) {
            increasedDate = null;
          } else if (this.isDateAvailable(increasedDate)) {
            return increasedDate;
          }
        }
        if (decreasedDate !== null) {
          decreasedDate.setDate(decreasedDate.getDate() - 1);
          if (this.minDate !== null && decreasedDate.getTime() < this.minDate.getTime()) {
            decreasedDate = null;
          } else if (this.isDateAvailable(decreasedDate)) {
            return decreasedDate;
          }
        }
        maxLoops--;
      } while ((increasedDate !== null || decreasedDate !== null) && maxLoops > 0);
      return null;
    };
    Options.prototype.isDateInValidity = function (date) {
      return this.calculateDateCorrection(date) === null;
    };
    Options.prototype.correctDate = function (date) {
      var correctDate = this.calculateDateCorrection(date);
      return correctDate !== null ? correctDate : date;
    };
    Options.prototype.getFirstDayOfWeek = function () {
      return this.firstDayOfWeek;
    };
    Options.prototype.areDaysOutOfMonthVisible = function () {
      return this.daysOutOfMonthVisible;
    };
    Options.prototype.hasFixedRowsCount = function () {
      return this.fixedRowsCount;
    };
    Options.prototype.hasToggleSelection = function () {
      return this.toggleSelection;
    };
    Options.prototype.isAllowedEmpty = function () {
      return this.allowEmpty;
    };
    Options.prototype.isDeselectButtonShown = function () {
      return this.showDeselectButton;
    };
    Options.prototype.isResetButtonShown = function () {
      return this.showResetButton;
    };
    Options.prototype.isMonthAsDropdown = function () {
      return this.monthAsDropdown;
    };
    Options.prototype.isYearAsDropdown = function () {
      return this.yearAsDropdown;
    };
    Options.prototype.getClassesPrefix = function () {
      return this.classesPrefix;
    };
    Options.prototype.isCloseButtonShown = function () {
      return this.showCloseButton;
    };
    Options.prototype.getTitle = function () {
      return this.title;
    };
    Options.prototype.getMinDate = function () {
      return this.minDate;
    };
    Options.prototype.getMaxDate = function () {
      return this.maxDate;
    };
    Options.prototype.getYearsSelectionLimits = function () {
      return this.yearsSelectionLimits;
    };
    Options.prototype.isDateAvailable = function (date) {
      if (this.dateAvailabilityResolver !== null) {
        return !!this.dateAvailabilityResolver(new Date(date.getTime()));
      }
      return true;
    };
    Options.prototype.getCellContent = function (day) {
      if (this.cellContentResolver !== null) {
        return this.cellContentResolver(day);
      }
      return day.dayNumber.toString();
    };
    Options.prototype.getCellClasses = function (day) {
      if (this.cellClassesResolver !== null) {
        var classes = this.cellClassesResolver(day);
        if (typeof classes === 'object' && classes.constructor === Array) {
          return classes;
        }
      }
      return [];
    };
    Options.prototype.getGoBackHtml = function () {
      return this.goBackHtml;
    };
    Options.prototype.getGoForwardHtml = function () {
      return this.goForwardHtml;
    };
    Options.prototype.getCloseHtml = function () {
      return this.closeHtml;
    };
    Options.prototype.getResetHtml = function () {
      return this.resetHtml;
    };
    Options.prototype.getDeselectHtml = function () {
      return this.deselectHtml;
    };
    Options.prototype.isHiddenOnBlur = function () {
      return this.hideOnBlur;
    };
    Options.prototype.isHiddenOnSelect = function () {
      return this.hideOnSelect;
    };
    Options.prototype.getInputFormat = function () {
      return this.inputFormat;
    };
    Options.prototype.checkConstraints = function (minDate, maxDate) {
      if (minDate !== null && maxDate !== null && minDate.getTime() > maxDate.getTime()) {
        throw new Error('Min date cannot be higher then max date.');
      }
    };
    Options.prototype.calculateMonthCorrection = function (month) {
      if (this.minDate !== null) {
        var minMonth = new Date(this.minDate.getTime());
        minMonth.setDate(1);
        if (month.getTime() < minMonth.getTime()) {
          return minMonth;
        }
      }
      if (this.maxDate !== null) {
        var maxMonth = new Date(this.maxDate.getTime());
        maxMonth.setDate(1);
        if (month.getTime() > maxMonth.getTime()) {
          return maxMonth;
        }
      }
      return null;
    };
    Options.prototype.calculateDateCorrection = function (date) {
      if (this.minDate !== null && date.getTime() < this.minDate.getTime()) {
        return new Date(this.minDate.getTime());
      }
      if (this.maxDate !== null && date.getTime() > this.maxDate.getTime()) {
        return new Date(this.maxDate.getTime());
      }
      return null;
    };
    Options.prototype.onEventListener = function (eventType, listener) {
      TheDatepicker.Helper.checkFunction('Event listener', listener, false);
      this.listeners[eventType].push(listener);
    };
    Options.prototype.offEventListener = function (eventType, listener) {
      TheDatepicker.Helper.checkFunction('Event listener', listener);
      if (listener === null) {
        this.listeners[eventType] = [];
      } else {
        var newListeners = [];
        for (var index = 0; index < this.listeners[eventType].length; index++) {
          if (this.listeners[eventType][index] !== listener) {
            newListeners.push(this.listeners[eventType][index]);
          }
        }
        this.listeners[eventType] = newListeners;
      }
    };
    Options.prototype.triggerEvent = function (eventType, caller) {
      for (var index = 0; index < this.listeners[eventType].length; index++) {
        if (caller(this.listeners[eventType][index]) === false) {
          return false;
        }
      }
      return true;
    };
    return Options;
  }());
  TheDatepicker.Options = Options;
})(TheDatepicker || (TheDatepicker = {}));

// Order day => Earliest pickup day
const pickupSchedule = {
  Monday: 'Wednesday',
  Tuesday: 'Thursday',
  Wednesday: 'Friday',
  Thursday: 'Monday',
  Friday: 'Tuesday' 
}
const closedPickupSchedule = {
  Monday: 'Tuesday',
  Tuesday: 'Wednesday',
  Wednesday: 'Thursday',
  Thursday: 'Friday',
  Friday: 'Monday' 
}

const timeOpen = 0
const timeClose = 1830

let pickupDay = '';
let nextDay

const currentShopDay = $('#current_shop_day').val() 
const currentShopTime = $('#current_shop_time').val()

console.log('currentShopTime='+currentShopTime+',currentShopDay='+currentShopDay )

if(timeOpen <= currentShopTime && currentShopTime <= timeClose) {
	if(currentShopDay in pickupSchedule) {
  	pickupDay = pickupSchedule[currentShopDay]
  } else {
  	pickupDay = pickupSchedule.Monday
  }
} else {
	if(currentShopDay in closedPickupSchedule) {
  	nextDay = closedPickupSchedule[currentShopDay]
  } else {
  	nextDay = 'Monday'
  }
  pickupDay = pickupSchedule[nextDay]
}

$('#schedule_pickup').text(pickupDay)
$('#schedule_pickup_val').val(pickupDay)

/** Regular pickup datepicker **/
const input = document.getElementsByClassName('datepicker');
if(input.length > 0) {
  var year = new Date().getFullYear();
  var yearEnd = (year + 5)
  var minDate = new Date();
  minDate.setDate(getDateNeeded(input[0].dataset.productId, minDate));
  const datepicker = new TheDatepicker.Datepicker(input[0]);
  datepicker.options.setMinDate(minDate);
  datepicker.options.setInputFormat('m/d/Y');
  datepicker.options.setYearsSelectionLimits(year, yearEnd);
  datepicker.options.setShowDeselectButton(false);
  datepicker.options.setShowCloseButton(false);
  datepicker.options.onBeforeSelect(function (event, day, previousDay) {
    if(day.isWeekend) {
      return false
    }
  })
  datepicker.render();
}

function getDateNeeded(productId, minDate) {
  switch(productId) {
    case '1365393899633':
    case '1376461914225':
    case '4353533149297':
      return minDate.getDate();
      break;
    case '4661418590321':
      return (minDate.getDate() + 5)
      break;
    case '4357752258673':
    case '4570717618289':  
      return (minDate.getDate() + 2)
      break;
    default:
      return (minDate.getDate() + 1)
      
  }
}
/** / Regular pickup datepicker **/
 
 
document.addEventListener('DOMContentLoaded', function() {
  var qty = document.getElementById('Quantity');
  if(qty != null) {
    qty.addEventListener('keyup', function() {

    var price = document.getElementById('ProductPrice');
      var newPrice = ((parseFloat(price.getAttribute('content')) * parseInt(qty.value)).toFixed(2))
      if(newPrice > 0) {
        price.innerText = '$'+newPrice
      } else {
        price.innerText = '$0'
      }
    });

    var theOptions = document.getElementsByClassName('single-option-selector');
    for(var i=0; i<theOptions.length; i++)
    {
      theOptions[i].addEventListener('change', function() {
      var qty = document.getElementById('Quantity');

      var price = document.getElementById('ProductPrice');
        var newPrice = ((parseFloat(price.getAttribute('content')) * parseInt(qty.value)).toFixed(2))
        if(newPrice > 0) {
          price.innerText = '$'+newPrice
        } else {
          price.innerText = '$0'
        }
      });
    }
  }
  /*
  // Hide paid shipping methods for one particular product 
  // https://liquiddreamsdesign.com/products/magnoila 
  if(document.getElementById('order-summary')) {
    
    let inCart = document.querySelectorAll('.product');
    if(inCart.length == 1) {
      if(inCart[0].dataset.productId == '6591690965105') {
        let shippingMethods = document.querySelectorAll('[data-shipping-method]');
        for (const shippingMethod of shippingMethods) {
          if(shippingMethod.dataset.shippingMethod != 'shopify-Economy-0.00') {
            shippingMethod.closest('.content-box__row').style.display = 'none'
          }
        }
      }
    }  
  }*/
  
  
  $('.remove_product_from_cart').on('click', function(e) {
    e.preventDefault()
    let self = this.href
    
    $(this).parents('.cart__row').remove()
    
    if($('.sdp').length == 0) {
      
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
            39523719151729: 0
          }
        },
        dataType: 'json',
        success: function() { 
			window.location.href = self
        },
        error: function() {
          window.location.href = self
        }
      });
    } else {
      
      window.location.href = self
    } 
  })
  
  
  $('#AddToCart').unbind('click')
  $('#AddToCart').on('click', function(e) {
    e.preventDefault();
    if($('#same_day_pickup:checked').length == 1) {
      
      
      jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(response) { 
          let hasSameDayProduct = false
          if(response.items.length > 0) {
            $.each(response.items, function(i, v) {
              if(v.id == 39523719151729) {
                hasSameDayProduct = true
                return
              }
            });
            if(hasSameDayProduct == false) {
              jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                        "id": 39523719151729,
                        "quantity": 1
                      },
                dataType: 'json',
                success: function() { 
                  $("form[id^='product_form']").submit()
                },
                error: function() {
                  alert('Something went wrong'); 
                }
              });
            } else {
              $("form[id^='product_form']").submit()
            }
          } else {
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                      "id": 39523719151729,
                      "quantity": 1
                    },
              dataType: 'json',
              success: function() { 
                $("form[id^='product_form']").submit()
              },
              error: function() {
                alert('Something went wrong'); 
              }
            });
          }
        }
      });
      
      return ;
      
    } else {
      
      $("form[id^='product_form']").submit()
      
     
    }/* else {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
        	39523719151729: 0
          }
      	},
        dataType: 'json',
        success: function() { 
          
        }
      });
    }*/
  });
  
  
  $('#same_day_pickup').on('change', function(e) {
    if (this.checked) {
      $('#schedule_pickup_val').attr('disabled', true).parent('.line-item-property__field').hide()
      //$('#date_needed').attr('required', false).attr('disabled', true).parent('.line-item-property__field').hide()
    } else {
      $('#schedule_pickup_val').attr('disabled', false).parent('.line-item-property__field').show()
      //$('#date_needed').attr('required', true).attr('disabled', false).parent('.line-item-property__field').show()
    }
  })
  
  //$('.cart__quantity-selector').attr('readonly', true)

  $("#select_finish li input[type='radio']").change(function(){
        // When change happens (radio button checked):
        // first, remove class 'checked' from all li tags
        $('#select_finish').find('li').removeClass("checked")
        // then, add class 'checked' to the parent li of this (checked) radio button
        $(this).parents('li').addClass("checked");
  })

  $("#select_shape li input[type='radio']").change(function(){
        // When change happens (radio button checked):
        // first, remove class 'checked' from all li tags
        $('#select_shape').find('li').removeClass("checked")
        // then, add class 'checked' to the parent li of this (checked) radio button
        $(this).parents('li').addClass("checked");
  })
  
}, false);

function chooseStickersOption() {
  var shape = $('input[name="properties[Shape]"]:checked').val();
  var size = $('select[name="properties[Size]"]').val();
  var finish = $('input[name="properties[Finish]"]:checked').val();
  var quantity = $('select[name="quantity"]').val();
  var customQuantity = $('input[name="properties[CustomQuantity]"]').val();
  var customWidth = $('input[name="properties[CustomWidth]"]').val();
  var customHeight = $('input[name="properties[CustomHeight]"]').val();
  var optionText = `${shape} / ${size} / ${finish}`;
  

  $("#ProductSelect-product-template-vinyl option").filter(function () {
    // Split the option text at the hyphen and take the first part (trimming to remove any unwanted space)
    var option = $(this).text().split(" - ")[0].trim();
    return option == optionText;
  }).prop('selected', true);

  if(size == 'CustomSize') {
    $('#custom_size_option').show();
    $('#custom_size_option').find('input').attr('disabled', false);
  } else {
    $('#custom_size_option').hide();
    $('#custom_size_option').find('input').attr('disabled', true);
  }

  var pricePerItem = 0.4;

  // Overriding the pricePerItem based on user selection
  switch (size) { 
    case '2x2':
      pricePerItem = 0.4;
      break;
    case '3x3':
      pricePerItem = 0.9;
      break;
    case '4x4':
      pricePerItem = 1.6;
      break;
    case '5x5':
      pricePerItem = 2.6;
      break;
    case 'CustomSize':
      var w = parseFloat(customWidth);
      var h = parseFloat(customHeight);
      pricePerItem = w*h/144*15;
      break;
    default:
      console.log('Invalid size');
  }

  //var getPrice = parseFloat($('#ProductPrice').attr('content'));
  if(quantity == 'CustomQuantity') {
    $('#custom_quantity_option').show();
    $('#custom_quantity_option').find('input').attr('disabled', false);
    if(customQuantity >= 1) {
      $('#Quantity').val(customQuantity)
      var q = parseInt(customQuantity, 10);
      var p = (pricePerItem * q);
    }
  } else {
    $('#custom_quantity_option').hide();
    $('#custom_quantity_option').find('input').attr('disabled', true);
    $('#Quantity').val(quantity)
    var q = parseInt($('select[name="quantity"]').val(), 10);
    var p = (pricePerItem * q);
  }
  if(p > 0) {
    $('#ProductPrice').show();
    $('#ProductPrice').text(`\$${p.toFixed(2)}`);
  } else {
    $('#ProductPrice').hide();
  }
}
